import { Component, ElementRef, OnInit, ViewChild,VERSION } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DataTableDirective } from 'angular-datatables';
declare var $: any;
import * as _ from 'lodash';

import { Subject } from 'rxjs';
import { CustomValidation } from 'src/app/helpers/customValidation';
import { GroupMasterService } from 'src/app/services/group-master.service';
import { TaskService } from 'src/app/services/task.service';
import { AlertComponent } from '../../alert/alert.component';
import { ActivatedRoute, Router } from '@angular/router';
import { CategoryMasterService } from 'src/app/services/category-master.service';
import { AgendaService } from 'src/app/services/agenda.service';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { environment } from 'src/environments/environment';
import { MeetingMasterService } from 'src/app/services/meeting-master.service';
import { ProcessMasterService } from 'src/app/services/process-master.service';
import { BranchAndDepartmentService } from 'src/app/services/branch-and-department.service';
import { AuthAlertComponent } from '../../auth-alert/auth-alert.component';
import { LoaderService } from 'src/app/services/loader.service';


@Component({
  selector: 'app-add-new-agenda',
  templateUrl: './add-new-agenda.component.html',
  styleUrls: ['./add-new-agenda.component.css']
})
export class AddNewAgendaComponent implements OnInit {

  public agendaTypeOption: any = [];
  public environmentSettings: any;
  public downloadAllLink: string;
  public downloadLink: string;
  public loading = false;
  public responseDepartment: any

  showOptionLable: string = "show More Option";
  agendaAddForm: FormGroup;
  imageAdd: boolean
  imageAddRev: boolean;
  imageEdit: boolean = false;

  minuteDocAdd: boolean;
  minuteDocEdit: boolean;
  minuteDocAddRev: boolean = false;
  meetingType: any[];
  agendaFiles = [];
  MinDocFiles = [];
  documentArr = [];
  documentArrMinDoc = []
  meetingTypes: any[];
  categories: any[];
  preDefinedTask: any[];
  preDefinedTasknew: any[];
  IsSelectedUpload: any;
  fileUpload: any;
  name: any;
  reader: any;
  filesToUpload: Array<File>;
  filesToUploadMinuteDocument: Array<File>;
  changedName: any = "";
  FileOrignalName: any;

  FileChangedName: any = new Array();
  FileNameOrignalDisplay: any = new Array();

  FileOrignalNameMinDoc: any;

  FileChangedNameMinDoc: any = new Array();
  FileNameOrignalDisplayMinDoc: any = new Array();
  documentsDownloadMinute: any;
  currentURL: any;
  isClickedOnce = false;
  agendaId: any;
  IscategorySelected123: any;
  IsMeetingAssigned123: any;

  selectedAll: any;
  IsSelectedTasks: any;
  companytasklist: any[] = [];
  agendaAddedTaskList: any[] = [];
  processes: any[] = [];
  addedProcess: any[] = [];
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptionsTaskAddingPopup: DataTables.Settings = {};
  dtTriggerTaskAddingPopup: Subject<any> = new Subject();

  dtOptionsForAddedTask: DataTables.Settings = {};
  dtTriggerForAddedTask: Subject<any> = new Subject();

  dtOptionsForAddedProcess: DataTables.Settings = {};
  dtTriggerForAddedProcess: Subject<any> = new Subject();

  dtOptionsProcessAddingPopup: DataTables.Settings = {};
  dtTriggerProcessAddingPopup: Subject<any> = new Subject();

  groupTypes: any[];
  groupID: any;
  SearchtaskEventbasedorPeriodicModel: any;
  SearchtaskUserdefinedorPredefinedModel: any;
  returnUrl: string;
  hasPermission: any;
  deletedTasks: any[];
  deletedProcesses: any[];
  selectedAllProcesses: any;
  isProcessSelected: boolean;
  isCategoryNoBoolean: boolean = false;

  documentsDownload: any[];
  actualFileName: any[];
  TotalFile: any = [{}];
  TotalFileMinDoc: any = [{}];
  orignalName: string;
  filenamedit: any;
  filenameoriginal: any;
  minFilenamedit: any;
  minFilenameoriginal: any;

  previousAgendafilename: any;
  previousAgendafileoriginal: any;
  PreambleAndResolution_DocId: any;
  token: any = localStorage.getItem('token')


  categoryDisabledOnclick: boolean = false;
  agendaDisabledOnclick: boolean = false;
  Minutes_DocId: any;
  indexGroupingList: any;
  GroupingIndex: any;
  GroupingName: any;
  GroupingNumber: any;
  groupName: any;
  groupNumber: any;
  typeHasError: boolean = false;
  typeHasError1: boolean = false;
  disabledOnclick: boolean;
  GroupingNumberTouched: boolean;
  agendaNameFieldTouched: boolean;
  GroupingNameTouched: boolean;

  disableOnEdit: boolean;
  hideCompliance: any;
  showCompliance: any;
  meetingTypesList: any[];
  meetingTypeName: any;
  deleteProcessId;
  deleteTaskId;
  preambleFileUpdateDate: any;
  minuteFileUpdateDate: any;


  @ViewChild('fileInput') el: ElementRef;
  constructor(
    private customValidation: CustomValidation,
    private groupMasterService: GroupMasterService,
    private taskService: TaskService,
    private alert: AlertComponent,
    private router: Router,
    private route: ActivatedRoute,
    private loaderService:LoaderService,
    private categoryMasterService: CategoryMasterService,
    private agendaService: AgendaService,
    private processMasterService: ProcessMasterService,
    private commonFunction: CommonFunction,
    private activatedRoute: ActivatedRoute,
    private meetingService: MeetingMasterService,
    private authAlert: AuthAlertComponent,
    private branchAndDepartmentService:BranchAndDepartmentService
  ) {

    this.name = `Angular v${VERSION.full} : File Upload`
    this.filesToUpload = [];
    this.filesToUploadMinuteDocument = [];
    this.currentURL = window.location.href;
  }

  catBoolean: boolean;
  meetingBoolean: boolean;
  categoryMasterForm: FormGroup;
  taskFormControl: FormGroup;
  ActualDataToAgenda: any[];
  PageTitle: any;
  FromMeetingmeetingID: any;
  FromMeetingmeetingTypeID: any;
  dataAdd: boolean = false;
  searcheFilteredDataTask: any[];
  searcheFilteredDataProcess: any[];
  markProcessSelected: boolean = false;
  AddNewAgendafiles: boolean = false;
  agendaDetailsCompanyID: any;

  ngOnDestroy(): void {
    // Re-enable loader when navigating away from this component
    this.loaderService.enable();
  }
  ngOnInit() {
    this.loaderService.disable();
    this.router.events.subscribe(() => {
      $('.modal-backdrop').remove();
      $('body').removeClass('modal-open');
    });

    this.downloadAllLink = environment.pssServerUrl + 'agenda/downloadAllAsZip/';
    this.downloadLink = environment.pssServerUrl + 'agenda/download/';

    this.environmentSettings = environment;
    this.SearchtaskEventbasedorPeriodicModel = '1'
    var hasEditPermission: any = false;
    this.regiserModalShowEvent();
    this.dtOptionsTaskAddingPopup = {
      destroy: true,
      scrollY: "250px",
      scrollX: true,
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      search: true,
      order: [2, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }],
    };
    this.dtOptionsForAddedTask = {
      destroy: true,
      scrollY: "250px",
      scrollX: true,
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      search: false,
      searching: true,
      order: [1, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [4] }],
    };
    this.dtOptionsForAddedProcess = {
      destroy: true,
      scrollY: "250px",
      scrollX: true,
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      search: true,
      searching: true,
      order: [1, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [3] }],
    };
    this.dtOptionsProcessAddingPopup = {
      destroy: true,
      scrollY: "250px",
      scrollX: true,
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      search: true,
      searching: true,
      order: [2, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }],
    };

    this.booleanMeetingValidate = false;
    this.booleanCategoryValidate = false;
    this.catBoolean = false;
    this.meetingBoolean = false;


    this.getMeetingTypeList('Company');
    // this.getCategoryList();
    this.agendaAddForm = new FormGroup({
      agendaNumber: new FormControl('', [Validators.required]),
      agendaNumberPrefix: new FormControl('', []),
      IscategorySelected: new FormControl('', [Validators.required]),//added Field
      IsMeetingAssigned: new FormControl('', [Validators.required]),//added Field
      meetingType: new FormControl('', [Validators.required]),
      selectCategory: new FormControl('', []),//Modified added field
      meeting: new FormControl('', []),// added field
      agendaTitle: new FormControl('', [Validators.required, this.customValidation.noWhitespaceValidator]),
      agendaCompliance: new FormControl('', []),
      name: new FormControl('', []),
      agendaType: new FormControl('', []),
      department: new FormControl('', []),
      image: new FormControl('', []),
      imageMinDoc: new FormControl('', []),
      indexGrouping_id: new FormControl('', [])
    });

    var lastSegOfURL = window.location.href.substr(window.location.href.lastIndexOf('/') + 1)
    this.refreshOnLoadTaskList()
    if (this.currentURL.includes('edit')) {
      hasEditPermission = this.commonFunction.validateURL('Agenda', 'edit');
      this.hasPermission = hasEditPermission;
      this.imageAdd = false;
      this.imageAddRev = false
      this.imageEdit = true;
      this.minuteDocEdit = true;
      this.minuteDocAdd = false;
      this.minuteDocAddRev = false


      this.activatedRoute.params.subscribe(params => {
        if (params['agendaId'] != undefined) {

          var data = {
            module: 'Agenda',
            ID: params['agendaId'],
            CompanyID: JSON.parse(localStorage.getItem("companyDetails")).companyID
          }

          this.meetingService.authonticateDataForComapnay(data).subscribe(meetingAccess => {
            if (meetingAccess.status == 0) {
              this.getFormDetaisOnEdit();
            } else {
              this.authAlert.validateModuleWithPermissions('Agenda', params['agendaId'], meetingAccess.companyID, 'edit')
            }
          })
        }
      })

      this.getpredefinedTaskList();
      $("#saveBtnAgenda").hide();
      $("#editBtnAgenda").show();
      // this.companytasklist = [];
      // var table1 = $('#companytaskTable').DataTable({ destroy: true });
      // table1.destroy();
      // this.getCompanyTaskListInUpdateAgenda();

    } else {
      
      this.onGetDepartmentDetails('');
      hasEditPermission = this.commonFunction.validateURL('Agenda', 'add');
      this.hasPermission = hasEditPermission;


      this.addedProcess = [];
      this.dtTriggerForAddedProcess.next();
      this.PageTitle = "Add Agenda"
      $('#addedtaskTable').DataTable({
        "searching": false,
        "lengthMenu": [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
        "columnDefs": [{ orderable: false, targets: [4] }],
        "language": {
          "emptyTable": "No data available in table"
        }
      });


      this.imageAddRev = false;
      $("#saveBtnAgenda").show();
      $("#editBtnAgenda").hide();
      this.getpredefinedTaskList();
      this.imageAdd = true;
      this.minuteDocAdd = true;
      this.minuteDocEdit = false;
      this.imageEdit = false;
      this.agendaAddForm.reset();
      this.agendaAddForm.controls.IsMeetingAssigned.setValue("No");
      this.agendaAddForm.controls.IscategorySelected.setValue("Yes");
      this.CheckCategory('Yes')
      // this.companytasklist = [];
      // var table2 = $('#companytaskTable').DataTable({ destroy: true });
      // table2.destroy();
      // this.getCompanyTaskList();
    }
    // console.log(this.imageAdd);
    this.categoryMasterForm = new FormGroup({
      CategoryName: new FormControl('', [Validators.required, Validators.maxLength(100), Validators.pattern("^[a-zA-Z0-9][a-zA-Z0-9 _@./$!#%&,()+-]*$")
      ]),
      IsGlobal: new FormControl('', [Validators.required]),
      isDefault: new FormControl('', [Validators.required]),
      MeetingType: new FormControl('', [Validators.required])
    });

    this.getGroupmasterList();


    this.preSelectedMeetingToAdd()


    // this.getProcessList()
    $('.modal-dialog').draggable({
      handle: ".modal-header"
    });

    $("#agendaTitle").focus();

    this.disableControl(hasEditPermission);

    var self = this;
    let table1 = $("#companytaskTable").DataTable();
    let table2 = $("#processTablePopup").DataTable();
    var searchedDataForSelectAll = [];

    table1.on('search.dt', function () {
      self.searcheFilteredDataTask = [];
      var tableData = $("#companytaskTable").DataTable().column(0, { search: 'applied' }).data();

      for (var i = 0; i < tableData.length; i++) {
        self.searcheFilteredDataTask.push(tableData[i])
      }

      var allSearchedSelected = true;
      if (_.size(self.companytasklist)) {
        for (var i = 0; i < self.companytasklist.length; i++) {
          for (var j = 0; j < self.searcheFilteredDataTask.length; j++) {
            if (self.searcheFilteredDataTask[j] == self.companytasklist[i].ID) {
              if (self.companytasklist[i].SelectedTasks) {
              } else {
                allSearchedSelected = false;
              }
            }
          }
        }
      }

      if (allSearchedSelected) {
        self.selectedAll = true;
      } else {
        self.selectedAll = false;
      }
      //console.log(self.searcheFilteredData);
    });

    table2.on('search.dt', function () {
      self.searcheFilteredDataProcess = [];
      //self.selectedAll=false;
      var tableData = $("#processTablePopup").DataTable().column(0, { search: 'applied' }).data();
      for (var i = 0; i < tableData.length; i++) {
        self.searcheFilteredDataProcess.push(tableData[i])
      }

      var allSearchedSelectedProcess = true;
      if (_.size(self.processes)) {
        for (var i = 0; i < self.processes.length; i++) {
          for (var j = 0; j < self.searcheFilteredDataProcess.length; j++) {
            if (self.searcheFilteredDataProcess[j] == self.processes[i]._id) {
              if (self.processes[i].IsSelected) {
              } else {
                allSearchedSelectedProcess = false;
              }
            }
          }
        }
      }

      if (allSearchedSelectedProcess) {
        self.selectedAllProcesses = true;
      } else {
        self.selectedAllProcesses = false;
      }
    });

    // $('#AddCompliancesDialog').on('show.bs.modal', function() {
    //   // do something when the modal is shown
    //   self.refreshOnLoadTaskList();
    // })
    this.getGroupIndex();

  }
  ngAfterViewInit() {
    $('#AddCompliancesDialog').on('hidden.bs.modal', () => {
      $('.modal-backdrop').remove();
      $('body').removeClass('modal-open');
      $('#AddCompliancesDialog').removeClass('show').hide(); // Full reset
    });
  }
  noBlankSpaceAtStart(ev) {
    if (ev.which === 32 && ev.target.selectionStart === 0) {
      return false;
    }
  }

  preSelectedMeetingToAdd() {
    if (localStorage.getItem('queryParams') != undefined || localStorage.getItem('queryParams') != null) {
      var obj = JSON.parse(localStorage.getItem('queryParams'));
      this.FromMeetingmeetingID = obj[0].meetingID;
      this.FromMeetingmeetingTypeID = obj[0].meetingTypeID;
      this.getMeetingFromType(obj[0].meetingTypeID)
      this.agendaAddForm.controls.meetingType.setValue(obj[0].meetingTypeID);
      this.agendaAddForm.controls.meeting.setValue(obj[0].meetingID);
      this.agendaAddForm.controls.IsMeetingAssigned.setValue('Yes');
      this.CheckAssignMeeting('Yes')


      // localStorage.removeItem('queryParams')
    }
  }


  getCompanyTaskList() {
    // var table2 = $('#companytaskTable').DataTable({ destroy: true });
    // table2.destroy();

    var companytaskWithAddedToShow = []
    var unique = []
    var data = [];
    this.taskService.getCompanyTaskList()
      .subscribe(taskList => {
        let checked = true;
        if (taskList.status == 0) {
          //var predefinedTaskList = $(taskList.tasksDatalist.TasksData).filter(function (i, n) { return n.TriggerType==1 });

          companytaskWithAddedToShow = taskList.tasksDatalist.TasksData;
          for (var i = 0; i < companytaskWithAddedToShow.length; i++) {
            if (companytaskWithAddedToShow[i].TriggerType == 1) {
              data.push(companytaskWithAddedToShow[i]);
            }
          }

          data.forEach(element => {
            var flag = true;
            if (this.agendaAddedTaskList) {
              for (var i = 0; i < this.agendaAddedTaskList.length; i++) {
                this.agendaAddedTaskList[i].IsNew = false;
                if (element.ID == this.agendaAddedTaskList[i].Task_id) {
                  flag = false;
                  break;
                }
              }
              if (flag) {
                // console.log('adding');
                unique.push(element);
              }
            } else {
              unique.push(element);
            }

          });



          this.companytasklist = unique;
          // console.log(unique);
          this.dtTriggerTaskAddingPopup.next();
        }

      });
  }

  getAgendaType() {
    this.agendaService.getAgendaTypeSearch(this.agendaAddForm.controls.agendaType.value).subscribe((agendaDetails:any) => {
      this.agendaTypeOption = [];
      if (agendaDetails.status == 0) {
        this.agendaTypeOption = agendaDetails.TotalTypes;
      }
    });
  }

  getCompanyTaskListInUpdateAgenda() {
    // console.log('----->>>>>', this.agendaAddedTaskList)

    var removeIndex = [];
    var companytaskWithAddedToShow = [];
    var companytaskWithoutAgendaTaskList = [];
    var data = [];
    this.taskService.getCompanyTaskList()
      .subscribe(taskList => {
        let checked = true;
        if (taskList.status == 0) {
          // var predefinedTaskList = $(taskList.tasksDatalist.TasksData).filter(function (i, n) { return n.TriggerType==1 });
          companytaskWithAddedToShow = taskList.tasksDatalist.TasksData;
          for (var i = 0; i < companytaskWithAddedToShow.length; i++) {
            if (companytaskWithAddedToShow[i].TriggerType == 1) {
              data.push(companytaskWithAddedToShow[i]);
            }
          }
          companytaskWithAddedToShow = data;
          for (var i = 0; i < companytaskWithAddedToShow.length; i++) {
            var flag = true;
            if (this.ActualDataToAgenda != null && this.ActualDataToAgenda != undefined && this.ActualDataToAgenda.length != 0) {
              for (var j = 0; j < this.ActualDataToAgenda.length; j++) {
                if (companytaskWithAddedToShow[i].ID == this.ActualDataToAgenda[j].Task_id) {
                  flag = false;
                  break;
                } else {
                }
              }
              if (flag) {
                companytaskWithoutAgendaTaskList.push(companytaskWithAddedToShow[i]);
              }
            }

          }
          companytaskWithAddedToShow = companytaskWithoutAgendaTaskList;
          this.companytasklist = companytaskWithAddedToShow
          this.dtTriggerTaskAddingPopup.next();
        }
      });
  }



  companyTaskListBySearchFilter(searchParameters) {

    this.companytasklist = [];
    var searchedData = [];
    var companytaskWithoutAgendaTaskList = [];
    var companytaskWithAddedToShow = [];
    var data = [];
    this.taskService.getCompanyTaskListBySearchFilters(searchParameters)
      .subscribe(taskList => {
        if (taskList.body.status == 0) {


          //remove alredy existing data
          if (this.agendaAddedTaskList) {
            //On Update show nont available Task from agenda in search filter  this.agendaAddedTaskList 
            companytaskWithAddedToShow = taskList.body.tasksDatalist.TasksData;
            for (var i = 0; i < companytaskWithAddedToShow.length; i++) {
              if (companytaskWithAddedToShow[i].TriggerType == 1) {
                data.push(companytaskWithAddedToShow[i]);
              }
            }

            searchedData = data;

            var k = 0;
            for (var i = 0; i < searchedData.length; i++) {
              var flag = true;
              for (var j = 0; j < this.agendaAddedTaskList.length; j++) {
                if (searchedData[i].ID == this.agendaAddedTaskList[j].Task_id) {
                  flag = false;
                  break;
                } else {
                }
              }
              if (flag) {
                companytaskWithoutAgendaTaskList.push(searchedData[i]);
              }
            }
            searchedData = companytaskWithoutAgendaTaskList;

            this.companytasklist = searchedData;
          } else {
            // console.log(taskList);
            companytaskWithAddedToShow = taskList.body.tasksDatalist.TasksData;
            for (var i = 0; i < companytaskWithAddedToShow.length; i++) {
              if (companytaskWithAddedToShow[i].TriggerType == 1) {
                data.push(companytaskWithAddedToShow[i]);
              }
            }
            this.companytasklist = data;
          }
          this.dtTriggerTaskAddingPopup.next();
        }
      })
  }

  onPopupAddProcessEvent() {
    // this.getProcessList();

    this.showAllProcesses()
    setTimeout(function () {
      $("#processTablePopup").DataTable().columns.adjust();
    }, 500);

            // Clean any leftover state just to be safe
            $('.modal-backdrop').remove();
            $('body').removeClass('modal-open');
            $('#AddProcessDialog').removeClass('show').hide();
          
            setTimeout(() => {
              $('#AddProcessDialog').modal('show');
            }, 100);
  }

  showAddComplaincePopup() {
    // Clean any leftover state just to be safe
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
    $('#AddCompliancesDialog').removeClass('show').hide();
  
    setTimeout(() => {
      $('#AddCompliancesDialog').modal('show');
    }, 100);
  }

  addCompliancesTaskToAgendaForm() {

    this.dataAdd = true
    // var addedFullData = this.companytasklist.filter(opt => opt.SelectedTasks).map(opt => opt);
    var addedFullData = [];
    this.companytasklist.forEach(element => {
      if (element.SelectedTasks) {
        addedFullData.push(element);
      }
    });
    var nonAdded = this.companytasklist;
    this.companytasklist = []
    var j = 0;
    for (var i = 0; i < nonAdded.length; i++) {
      if (nonAdded[i].SelectedTasks == true) {
        // console.log(nonAdded[i]);
      } else {
        this.companytasklist[j] = nonAdded[i];
        j++;
      }
    }
    var table1 = $('#addedtaskTable').DataTable({ destroy: true });
    table1.destroy();

    var table2 = $('#companytaskTable').DataTable({ destroy: true });
    table2.destroy();

    var storingDataToAgenda = [];
    var existingDataOfAgenda = this.ActualDataToAgenda
    var i = 0;



    addedFullData.forEach(element => {
      storingDataToAgenda[i] = {
        Task_id: element.ID,
        TaskID: element.TaskID,
        TaskName: element.TaskName,
        TaskDescription: element.TaskDescription,
        GroupID: element.GroupID,
        GroupName: element.GroupName,
        IsGlobal: element.IsGlobal,
        IsNew: true
      }
      i++;
    });
    if (this.agendaAddedTaskList) {
      this.agendaAddedTaskList = this.agendaAddedTaskList.concat(storingDataToAgenda);
    }
    else if (existingDataOfAgenda) {
      this.agendaAddedTaskList = existingDataOfAgenda.concat(storingDataToAgenda);
    }
    else {
      this.agendaAddedTaskList = storingDataToAgenda;
    }

    this.dtTriggerTaskAddingPopup.next()
    this.dtTriggerForAddedTask.next();
    // console.log(this.agendaAddedTaskList);
    $('#AddCompliancesDialog').off('hidden.bs.modal');   
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
    $('#AddCompliancesDialog').modal('hide');

 
  }
  addProcessToAgendaForm() {


    var table = $('#processTablePopup').DataTable({ destroy: true });
    table.destroy();
    var table2 = $('#processTable').DataTable({ destroy: true });
    table2.destroy();
    var checkedProcesses = this.processes.filter(opt => opt.IsSelected).map(opt => opt);
    var addedProcess = this.addedProcess;
    var allProcess = this.processes;

    // this.addedProcess = [];
    for (var j = 0; j < checkedProcesses.length; j++) {
      checkedProcesses[j].IsNew = true;
      var index = this.indexOfElementArray(allProcess, checkedProcesses[j]);
      // console.log(index);
      allProcess.splice(index, 1);
    }


    // for(var i=0;i<allProcess.length;i++){
    //   var addedBoolean=false;
    //   for(var j=0;j<checkedProcesses.length;j++){

    //     if(allProcess[i]._id==checkedProcesses[j]._id){
    //       console.log(allProcess[i]._id);
    //       console.log(checkedProcesses[j]._id);
    //       addedBoolean=true;
    //       break;
    //     }

    //   }
    //   if(addedBoolean){
    //     //remove index i from processes
    //     allProcess.splice(i,1);
    //   }
    // }
    this.addedProcess = [];
    this.processes = [];
    this.addedProcess = addedProcess.concat(checkedProcesses);
    this.processes = allProcess;
    this.dtTriggerProcessAddingPopup.next();
    this.dtTriggerForAddedProcess.next();
    $('#AddProcessDialog').off('hidden.bs.modal');   
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
    $('#AddProcessDialog').modal('hide');
  }

  removeTaskFromAgendaList(deletingTask_id, isTaskGlobal) {
    var localStorageCompanyId = JSON.parse(localStorage.getItem("companyDetails")).companyID;
    // *** Global task selected in any AGENDA of one company should not be allowed for deleting from any company ***
    console.log('localStorageCompanyId : ' + localStorageCompanyId + '  this.agendaDetailsCompanyID: ' + this.agendaDetailsCompanyID + ' isTaskGlobal : ' + isTaskGlobal);
    if (localStorageCompanyId != this.agendaDetailsCompanyID && isTaskGlobal) {
      $('#addWarningText').text("Task cannot be deleted as it is already selected in Agenda by one Company");
      $('#warningModal').modal('toggle');
    } else {

      var table = $('#addedtaskTable').DataTable({ destroy: true });
      table.destroy();

      if (_.size(this.deletedTasks)) {
        this.deletedTasks.push(deletingTask_id);
      } else {
        this.deletedTasks = [];
        this.deletedTasks.push(deletingTask_id);
      }



      for (var i = 0; i < this.agendaAddedTaskList.length; i++) {
        var cur = this.agendaAddedTaskList[i];
        if (cur.Task_id == deletingTask_id) {
          this.agendaAddedTaskList.splice(i, 1);
          break;
        }
      }

      this.dtTriggerForAddedTask.next()
      this.refreshTaskList();
      // this.getCompanyTaskList()
    }
  }

  refreshOnLoadTaskList() {
    var self = this;
    setTimeout(function () {
      self.refreshTaskList();
    }, 500)
  }

  refreshTaskList() {
    var self = this;
    if (this.currentURL.includes('edit')) {
      var table = $('#companytaskTable').DataTable({ destroy: true });
      table.destroy();
      // this.getCompanyTaskListInUpdateAgenda();
      setTimeout(function () {
        self.getCompanyTaskListInUpdateAgenda();
      }, 1000)
    } else {
      var table = $('#companytaskTable').DataTable({ destroy: true });

      table.destroy();
      this.getCompanyTaskList();
    }
    $("#groupdropdown").val("null");

    this.groupID = null;
    this.selectedAll = false;
    this.SearchtaskEventbasedorPeriodicModel = '1';
    this.SearchtaskUserdefinedorPredefinedModel = null;
  }

  getSelectedGroupID(ev) {
    var id = ev.target.value;
    this.groupID = id;
  }

  showTasksBySearchData() {
    var searchParameters = {
      EventBasedorPeriodic: this.SearchtaskEventbasedorPeriodicModel,
      UserdefinedorPredefined: this.SearchtaskUserdefinedorPredefinedModel,
      GroupId: this.groupID
    };

    if (searchParameters.EventBasedorPeriodic != undefined || searchParameters.GroupId != undefined || searchParameters.UserdefinedorPredefined != undefined) {
      var table = $('#companytaskTable').DataTable({ destroy: true });
      table.destroy();
      this.companyTaskListBySearchFilter(searchParameters);
    }
    // console.log(searchParameters);
  }


  getGroupmasterList() {
    this.groupTypes = [];
    this.groupMasterService.getGroupList()
      .subscribe((groupList:any) => {
        if (groupList.status == 0) {
          //this.groupTypes = groupList.groupList;
          this.groupTypes = this.commonFunction.sortByKey(groupList.groupList, 'GroupName');
        }
      })
  }

  checkAllIfselectAll() {
    for (var i = 0; i < this.companytasklist.length; i++) {
      for (var j = 0; j < this.searcheFilteredDataTask.length; j++) {
        if (this.searcheFilteredDataTask[j] == this.companytasklist[i].ID) {
          this.companytasklist[i].SelectedTasks = this.selectedAll;
          this.IsSelectedTasks = this.selectedAll;
        }
      }
    }
  }

  checkIfAllSelected() {
    this.selectedAll = this.companytasklist.every(function (item: any) {
      return item.SelectedTask == true;

    })
  }

  checkselected(ev) {

    if (ev.target.checked == true) {
      this.IsSelectedTasks = true;
    }
    else {
      this.IsSelectedTasks = false;
    }
    var allSearchedSelected = true;
    if (_.size(this.companytasklist)) {
      for (var i = 0; i < this.companytasklist.length; i++) {
        for (var j = 0; j < this.searcheFilteredDataTask.length; j++) {
          if (this.searcheFilteredDataTask[j] == this.companytasklist[i].ID) {
            if (this.companytasklist[i].SelectedTasks) {
            } else {
              allSearchedSelected = false;
            }
          }
        }
      }
    }
    if (allSearchedSelected) {
      this.selectedAll = true;
    } else {
      this.selectedAll = false;
    }
  }


  CheckCategory(decision: any) {
    // console.log(decision);
    if (decision == 'Yes') {
      this.catBoolean = true;
      this.agendaAddForm.controls.IsMeetingAssigned.setValue('No');
      this.CheckAssignMeeting('No');
      this.isCategoryNoBoolean = false;
    } else {
      this.catBoolean = false;
      this.isCategoryNoBoolean = true;
    }
  }

  CheckAssignMeeting(decision: any) {
    if (decision == 'Yes') {
      this.meetingBoolean = true
      this.agendaAddForm.controls.IscategorySelected.setValue('No');
      this.CheckCategory('No');
    } else {
      this.meetingBoolean = false;
    }
  }

  upload(agendaTitle, meetingType) {
    var file = this.filesToUpload;
    // console.log('this.filesToUpload',file);
    this.makeFileRequest1(environment.pssServerUrl + "agenda/UploadFiles", [], file, agendaTitle, meetingType).then((result) => {
      // console.log(result);
    });
  }

  fileChangeEvent(fileInput: any) {
    try {
      // this.filesToUpload = <Array<File>>fileInput.target.files;
      this.typeHasError = false;
      var checkfile = this.commonFunction.checkFileExtensionForMeetingAgendaDocuments(fileInput);
      if (checkfile) {

        var filenameValidation = this.commonFunction.checkIfFileNameIsCorrect(fileInput,fileInput)
	      if(filenameValidation == "Valid"){
          this.filesToUpload = fileInput.target.files;
          let list = new DataTransfer()
          let file = this.filesToUpload[0];
          let blob = file.slice(0, file.size, 'image/png');
          let newFile = new File([blob], this.commonFunction.sanitizedFileName(file.name), { type: 'image/png' });
          list.items.add(newFile)
          this.filesToUpload = <any>list.files
          this.typeHasError = false;
        }else{
          this.alert.error(filenameValidation);
          this.typeHasError = true;
        }
      } else {
        this.typeHasError = true;
        this.alert.error("Invalid file extension");
      }
      fileInput = null;
    } catch (error) {
      console.log(error)
    }
  }

  fileChangeEventMinuteDocument(fileInputForMin: any) {
    // this.filesToUploadMinuteDocument = <Array<File>>fileInputForMin.target.files;
    this.typeHasError1 = false;
    var checkfile = this.commonFunction.checkFileExtensionForAgendaDocuments(fileInputForMin);
    if (checkfile) {
      var filenameValidation = this.commonFunction.checkIfFileNameIsCorrect(fileInputForMin,fileInputForMin)
	    if(filenameValidation == "Valid"){
        this.filesToUploadMinuteDocument = <Array<File>>fileInputForMin.target.files;
        this.typeHasError1 = false;
      }else{
        this.alert.error(filenameValidation);
        this.typeHasError1 = true;
      }
    } else {
      this.typeHasError1 = true;
      this.alert.error("Invalid file extension");
    }
    fileInputForMin = null;
  }

  uploadMinuteDcoument(agendaTitle, meetingType) {
    var file = this.filesToUploadMinuteDocument
    this.makeFileRequestMinuteDoc(environment.pssServerUrl + "agenda/UploadFiles", [], file, agendaTitle, meetingType).then((result) => {
      // console.log(result);
    });
  }
  makeFileRequestMinuteDoc(url: string, params: Array<string>, files: Array<File>, agendaTitle: string, meetingType: string) {
    return new Promise((resolve, reject) => {
      var formData: any = new FormData();
      var self = this;
      console.log('testest---------------')
      var xhr = new XMLHttpRequest();
      for (var i = 0; i < files.length; i++) {
        var newDate = Date.now();
        self.FileNameOrignalDisplayMinDoc.push(files[i].name.replace(',', ''));
        formData.append("file", files[i], newDate + '-' + files[i].name.replace(',', ''));
        self.FileChangedNameMinDoc.push(files[i].name.replace(',', ''));

        var document = {
          "DocumentName": agendaTitle + " - Agenda Document - " + i,
          "DateOfDocument": new Date(),
          "CompletedDate": null,
          "MeetingTypeID": meetingType,
          "ParentDocumentTypeID": null,
          "ParentSubDocumentTypeID": null,
          "DirectorKmp": "None",
          "DirectorID": null,
          "KMPID": null,
          "Remarks": "",
          "Overwrite": false,
          "Filename": newDate + '-' + files[i].name.replace(',', ''),
          "OriginalFileName": files[i].name.replace(',', ''),
          // "FilePath": "D:\\Harrier\\PSSProject\\pss_api\\uploads\\Document_Type\\",
          "CreatedBy": null,
          "CreatedDate": new Date(),
          "LastUpdateFiles": new Date(),
          "ModifiedBy": null,
          "ModifiedDate": null,
          "CompanyID": JSON.parse(localStorage.getItem("companyDetails")).companyID
        }
        self.documentArrMinDoc.push(document);
        console.log('tetttttlllpppp', self.documentArrMinDoc)
      }
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          if (xhr.status == 200) {
            resolve(JSON.parse(xhr.response));
          } else {
            reject(xhr.response);
          }
        }
      }
      xhr.open("POST", url, true);
      var token = localStorage.getItem('token')
      xhr.setRequestHeader('x-access-token', token)
      xhr.send(formData);
    });
  }



  makeFileRequest1(url: string, params: Array<string>, files: Array<File>, agendaTitle: string, meetingType: string) {
    return new Promise((resolve, reject) => {
      var formData: any = new FormData();
      var self = this;
      var xhr = new XMLHttpRequest();
      for (var i = 0; i < files.length; i++) {
        var newDate = Date.now();
        self.FileNameOrignalDisplay.push(files[i].name.replace(',', ''));
        formData.append("file", files[i], newDate + '-' + files[i].name.replace(',', ''));
        self.FileChangedName.push(files[i].name.replace(',', ''));
        //console.log('this.FileChangedName', this.FileChangedName);
        // console.log('this.FileorignalName', this.FileNameOrignalDisplay);

        var document = {
          "DocumentName": agendaTitle + " - Agenda Document - " + i,
          "DateOfDocument": new Date(),
          "CompletedDate": null,
          "MeetingTypeID": meetingType,
          "ParentDocumentTypeID": null,
          "ParentSubDocumentTypeID": null,
          "DirectorKmp": "None",
          "DirectorID": null,
          "KMPID": null,
          "Remarks": "",
          "Overwrite": false,
          "Filename": newDate + '-' + files[i].name.replace(',', ''),
          "OriginalFileName": files[i].name.replace(',', ''),
          // "FilePath": "D:\\Harrier\\PSSProject\\pss_api\\uploads\\Document_Type\\",
          "CreatedBy": null,
          "CreatedDate": new Date(),
          "LastUpdateFiles": new Date(),
          "ModifiedBy": null,
          "ModifiedDate": null,
          "CompanyID": JSON.parse(localStorage.getItem("companyDetails")).companyID
        }
        self.documentArr.push(document);
      }
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          if (xhr.status == 200) {
            resolve(JSON.parse(xhr.response));
          } else {
            reject(xhr.response);
          }
        }
      }
      xhr.open("POST", url, true);
      var token = localStorage.getItem('token')
      xhr.setRequestHeader('x-access-token', token)
      xhr.send(formData);
    });
  }


  // makeFileRequest(url: string, params: Array<string>, files: Array<File>) {
  //   return new Promise((resolve, reject) => {
  //     var formData: any = new FormData();
  //     var xhr = new XMLHttpRequest();
  //     for (var i = 0; i < files.length; i++) {
  //       formData.append("file", files[i], Date.now() + '-' + files[i].name.replace(',', ''));
  //       //this.agendaAddForm.controls.uploadFile.setValue(formData);
  //       this.FileOrignalName = files[i].name.replace(',', '');
  //       this.changedName = Date.now() + '-' + files[i].name.replace(',', '');
  //     }
  //     xhr.onreadystatechange = function () {
  //       if (xhr.readyState == 4) {
  //         if (xhr.status == 200) {
  //           resolve(JSON.parse(xhr.response));
  //         } else {
  //           reject(xhr.response);
  //         }
  //       }
  //     }
  //     xhr.open("POST", url, true);
  //     xhr.send(formData);
  //   });
  // }


  getMeetingTypeList(val) {
    this.meetingTypes = [];
    // if (val == 'Global') {
    var self = this;
    this.processMasterService.getMeetingTypeList()
      .subscribe(meetingTypeList => {
        if (meetingTypeList.status == 0) {
          this.meetingTypes = this.commonFunction.sortByKey(meetingTypeList.meetingTypeList, 'MeetingType');
          if (val == 'Global') {

            // _.filter(self.meetingTypes, function (obj, index) {
            //   if (obj.Committee) {
            //     if (obj.Committee.CommitteeName == 'Other') {
            //       self.meetingTypes.splice(index, 1);
            //     }
            //   }
            // })
            self.meetingTypes.forEach((obj, index) => {
              if (obj.Committee) {
                if (obj.Committee.CommitteeName == 'Other') {
                  self.meetingTypes.splice(index, 1);
                }
              }
            })
          }
        }
      })
    // } else {
    //   this.processMasterService.getMeetingTypeList()
    //     .subscribe(meetingTypeList => {
    //       if (meetingTypeList.status == 0) {
    //         this.meetingTypes = this.commonFunction.sortByKey(meetingTypeList.meetingTypeList, 'MeetingType');
    //       }
    //     })
    // }
    // this.meetingType = [
    //   { id: '1', name: 'Board' },
    //   { id: '2', name: 'Independent Directors' },
    //   { id: '3', name: 'Annual General Meeting' },
    //   { id: '4', name: 'Extraordinary General Meeting' },
    //   { id: '5', name: 'Postal Ballot' },
    //   { id: '5', name: 'Others' },
    // ];
  }

  getMeetingNameById() {
    $("#meetingTypeName").val('');
    setTimeout(() => {
      if (this.meetingTypeName) {
        $("#meetingTypeName").val(this.meetingTypeName);
      }
      $('#meetingTypeName').prop("disabled", true);
    }, 300);


    // let meetingTypeId = this.agendaAddForm.controls.meetingType.value;
    // $("#meetingTypeName").val('');
    // this.categoryMasterService.getMeetingNameById(meetingTypeId)
    //   .subscribe(res => {
    // $("#meetingTypeName").val('');
    // if (res.status == 0) {
    // let meetingTypeName = res.meetingDetails[0].MeetingType;
    // $("#meetingTypeName").val(meetingTypeName);
    // $('#meetingTypeName').prop("disabled", true);
    // }
    // })
  }

  getCategoryList() {
    this.categories = [];
    this.categoryMasterService.getCategoryList()
      .subscribe(categoryList => {
        if (categoryList.status == 0) {
          this.categories = this.commonFunction.sortByKey(categoryList.categoryList, 'CategoryName');
        }
      });
  }


  // getCategoryList(meetingTypeID) {

  //   this.categories = [];
  //   this.categoryMasterService.getCategoryListByMeetingTypeID(meetingTypeID)
  //     .subscribe(categoryList => {
  //       if (categoryList.status == 0) {
  //         this.categories =  this.commonFunction.sortByKey(categoryList.categoryList, 'CategoryName');;
  //         console.log(this.categories);
  //       }
  //     });
  // }

  getpredefinedTaskList() {
    this.preDefinedTask = [];
    this.agendaService.getpredefinedTask().subscribe(tasklist => {
      if (tasklist.status == 0) {
        this.preDefinedTasknew = tasklist.taskList;
        // console.log('( this.preDefinedTaskNew)', this.preDefinedTasknew);
        // console.log('( this.preDefinedTask)', this.preDefinedTask);
        var removingKeyArr = [];
        if (this.preDefinedTask.length > 0) {
          var newtsk = [];
          newtsk = this.preDefinedTasknew;
          for (var key in this.preDefinedTasknew) {
            for (var key2 in this.preDefinedTask) {
              if (this.preDefinedTasknew[key].TaskName == this.preDefinedTask[key2].TaskName) {
                removingKeyArr = removingKeyArr.concat(key);
                newtsk.splice(parseInt(key), 1);
              }
            }//second For Loop
          }//first for loop
          this.preDefinedTasknew = newtsk;
        }//if-->checking available task for edit to remove duplicates
      }//if-->checking status of api
    })
  }

  getSelectedTaskList(taskList) {
    var Arr = [];
    var newArr = [];
    Arr = taskList.split(',');
    //  console.log('taskList','--->'+taskList+'<----');
    if (taskList != "") {
      for (var i = 0; i < Arr.length; i++) {
        var element = Arr[i];
        newArr = newArr.concat({ TaskName: element });
      }
      this.preDefinedTask = newArr;
    }
  }

  revert() {
    this.imageAdd = false;
    this.imageAddRev = false;
    this.imageEdit = true;
  }

  revertDocMin() {
    this.minuteDocAdd = false;
    this.minuteDocAddRev = false;
    this.minuteDocEdit = true;
  }

  removeDoc() {
    this.imageAdd = true;
    this.imageAddRev = true;
    this.imageEdit = false;
    this.AddNewAgendafiles = false;
    this.agendaFiles = [];

  }

  addNewDoc() {
    this.imageAdd = true;
    this.imageEdit = false;
    this.imageAddRev = true;
    // this.AddNewAgendafiles = true; //If want to add multiple files keeping existing unchanged
    this.AddNewAgendafiles = false;
  }

  addNewMinDoc() {
    this.minuteDocAdd = true;
    this.minuteDocEdit = false;
    this.minuteDocAddRev = true;
  }

  back() {
    // this.agendaAddForm.reset();
 
    // this.alert.successWithOk("OK", function() {
    var fromMeeting = localStorage.getItem('fromMeeting');
    var returnCtx = localStorage.getItem('agendaAddReturnContext');
    localStorage.removeItem('fromMeeting');
    localStorage.removeItem('agendaAddReturnContext');
    // localStorage.removeItem('fromMeeting');
    if (fromMeeting != undefined || fromMeeting != null) {
      if (returnCtx === 'circular') {
        this.router.navigate(
          [{ outlets: { 'structure-outlet': ['addCircular', 'edit', fromMeeting] } }],
          { relativeTo: this.route.parent });
      } else {
        this.router.navigate(
          [{ outlets: { 'structure-outlet': ['addMeetings', 'edit', fromMeeting, 'Agenda'] } }],
          { relativeTo: this.route.parent });
      }
      // this.router.navigate(['meeting/edit/' + fromMeeting + '/Agenda']);
    } else {
      this.router.navigate(
        [{ outlets: { 'structure-outlet': ['agenda']  } }],
        { relativeTo: this.route.parent });
      // this.router.navigate(['agenda']);
    }
    //   alert('a');
 
    // });
    //this.alert.successWithOk("OK",'/agenda');
  }


  isChangeToMeeting: any;

  getFormDetaisOnEdit() {
    // console.log(this.currentURL);
    this.activatedRoute.params.subscribe(params => {
      if (params['agendaId'] != undefined) {
        // it is edit page

        var localStorageCompanyId = JSON.parse(localStorage.getItem("companyDetails")).companyID;

        // console.log('localStorageCompanyId : ' + localStorageCompanyId);

        this.agendaId = params['agendaId'];

        // let companyID = JSON.parse(localStorage.getItem("companyDetails")).companyID;

        this.agendaService.getAgendaDetaisByID(this.agendaId).subscribe(agendaDetails => {


          if (agendaDetails.status == 0) {
            var existingDataOfProcess = agendaDetails.agendaDetails[0].Processes;
            existingDataOfProcess.forEach(element => {
              element.IsNew = false;
            });
            
            // ======== Check Process Is Global , Pedefined and company **** Start ****
            this.agendaDetailsCompanyID = agendaDetails.agendaDetails[0].CompanyID;
            var resultArray: Array<any> = []
            existingDataOfProcess.forEach(processData => {
              if (processData.CompanyId == localStorageCompanyId && processData.IsGlobal == false && processData.IsPredefined == false) {
                resultArray.push(processData);
              }
              else if (processData.IsGlobal == true) {
                resultArray.push(processData);
              }
              else if (processData.PSSMasterProcessID != "" && processData.PSSMasterProcessID != undefined && processData.IsPredefined == true) {
                var processDataObj = {
                  PSSMasterProcessID: processData.PSSMasterProcessID,
                  IsPredefined: processData.IsPredefined,
                  CompanyId: localStorageCompanyId
                }
                this.processMasterService.verifyProcessData(processDataObj)
                  .subscribe(Result => {
                    if (Result.processData.length > 0) {
                      resultArray.push(processData);
                      var table1 = $('#processTable').DataTable({ destroy: true });
                      table1.destroy();
                      this.dtTriggerForAddedProcess.next();
                    }
                  })
              }
            });
            this.addedProcess = resultArray;
            // =========== Check Process Is Global , Pedefined and company **** End ****
            //this.addedProcess = existingDataOfProcess;
            console.log('------->>>>>>', resultArray);
            // console.log('agendaDetails', agendaDetails.agendaDetails[0].IsMeetingAssigned);
            // console.log('agendaDetails', agendaDetails.agendaDetails[0].meetingID);
            if (agendaDetails.agendaDetails[0].IsMeetingAssigned === 'Yes') {
              this.getMeetingFromType(agendaDetails.agendaDetails[0].MeetingTypeID)
              this.agendaAddForm.controls.meetingType.disable();
              this.agendaAddForm.controls.IscategorySelected.disable();
              this.agendaAddForm.controls.IsMeetingAssigned.disable();
              this.agendaAddForm.controls.meeting.disable();
              this.isChangeToMeeting = "Yes"
            } else {
              this.isChangeToMeeting = "No"
            }
            // this.agendaAddForm.controls.meeting.setValue(agendaDetails.agendaDetails[0].meetingID);
            var agendaNumber = agendaDetails.agendaDetails[0].AgendaNumber;
            var IscategorySelected = agendaDetails.agendaDetails[0].IscategorySelected;//added Field
            var IsMeetingAssigned = agendaDetails.agendaDetails[0].IsMeetingAssigned;//added Field
            var meetingType = agendaDetails.agendaDetails[0].MeetingTypeID;
            var selectCategory = agendaDetails.agendaDetails[0].CategoryID;//Modified added field
            var meeting = agendaDetails.agendaDetails[0].meetingID;// added field
            var agendaTitle = agendaDetails.agendaDetails[0].AgendaTitle;
            this.PageTitle = agendaTitle;
            var agendaCompliance = agendaDetails.taskList;
            var image = agendaDetails.agendaDetails[0].PreambleAndResolution_FileName;
            this.PreambleAndResolution_DocId = agendaDetails.agendaDetails[0].PreambleAndResolution_DocId;
            var libaryType = agendaDetails.agendaDetails[0].libaryType;
            var agendaType = agendaDetails.agendaDetails[0].agendaType;
            var agendaType = agendaDetails.agendaDetails[0].agendaTypeSelection;
            var department =agendaDetails.agendaDetails[0].departmentID;
            // var department = agendaDetails.agendaDetails[0].department
            this.agendaFiles = agendaDetails.agendaDetails[0].AgendaFiles;
            this.CheckCategory(IscategorySelected)
            this.CheckAssignMeeting(IsMeetingAssigned)
            var table = $('#addedtaskTable').DataTable({ destroy: true });
            table.destroy();

            var table1 = $('#processTable').DataTable({ destroy: true });
            table1.destroy();

            var table2 = $('#processTablePopup').DataTable({ destroy: true });
            table2.destroy();

            this.processes = [];



            //-------------------------------------------------------------------------------------------------------------------

            // for (var j = 0; j < this.addedProcess.length; j++) {
            //   var index = this.indexOfElementArray(this.processes, this.addedProcess[j]);
            //   console.log(index);
            //   this.processes.splice(index, 1);
            // }

            this.dtTriggerProcessAddingPopup.next();
            this.dtTriggerForAddedProcess.next();
            var existingDataOfAgenda = agendaDetails.taskList;
            // agendaDetails.taskList;

            existingDataOfAgenda.forEach(element => {
              element.IsNew = false;
            });
            var showCompliance = [];
            var hideCompliance = [];

            _.filter(existingDataOfAgenda, function (obj) {
              if (obj.IsPredefined && obj.CompanyID == JSON.parse(localStorage.getItem("companyDetails")).companyID) {
                showCompliance.push(obj);
              } else if (obj.IsGlobal || obj.CompanyID == JSON.parse(localStorage.getItem("companyDetails")).companyID) {
                // filter compliances => comp specific or global
                showCompliance.push(obj);
              } else {
                hideCompliance.push(obj);
              }
            });
            this.hideCompliance = hideCompliance;
            this.showCompliance = showCompliance;

            this.agendaAddedTaskList = showCompliance;
            this.dtTriggerForAddedTask.next();
            // console.log("agendaDetails", agendaDetails);
            this.ActualDataToAgenda = agendaDetails.taskList;
            this.meetingTypeName = agendaDetails.agendaDetails[0].meetingType_master.MeetingType;
            this.agendaAddForm.controls.agendaNumber.setValue(agendaDetails.agendaDetails[0].AgendaNumber);
            this.agendaAddForm.controls.meetingType.setValue(agendaDetails.agendaDetails[0].MeetingTypeID);
            // this.agendaAddForm.controls.selectCategory.setValue(agendaDetails.agendaDetails[0].CategoryID);
            this.agendaAddForm.controls.agendaTitle.setValue(agendaDetails.agendaDetails[0].AgendaTitle);
            this.agendaAddForm.controls.agendaCompliance.setValue(agendaDetails.taskList);
            this.agendaAddForm.controls.agendaType.setValue(agendaDetails.agendaDetails[0].agendaTypeSelection);
            // console.log(agendaDetails.agendaDetails[0].departmentID)
            this.onGetDepartmentDetails(agendaDetails.agendaDetails[0].departmentID);
            
            this.agendaAddForm.controls.IscategorySelected.setValue(agendaDetails.agendaDetails[0].IscategorySelected);
            this.agendaAddForm.controls.IsMeetingAssigned.setValue(agendaDetails.agendaDetails[0].IsMeetingAssigned);
            this.agendaAddForm.controls.meeting.setValue(agendaDetails.agendaDetails[0].meetingID);
            this.agendaAddForm.controls.selectCategory.setValue(agendaDetails.agendaDetails[0].CategoryID);
            this.agendaAddForm.controls.agendaNumberPrefix.setValue(agendaDetails.agendaDetails[0].agendaNumberPrefix);
            // this.getSelectedTaskList(agendaDetails.taskList)
            if (IscategorySelected == undefined || IscategorySelected == null || IscategorySelected == "null") { this.agendaAddForm.controls.selectCategory.setValue(null); }
            if (IsMeetingAssigned == undefined || IsMeetingAssigned == null || IsMeetingAssigned == "null") { this.agendaAddForm.controls.meeting.setValue(null); }

            this.agendaAddForm.controls.imageMinDoc.setValue(agendaDetails.agendaDetails[0].MinuteDocument_fileName);
            this.agendaAddForm.controls.indexGrouping_id.setValue(agendaDetails.agendaDetails[0].indexGrouping_id);
            // console.log('file details------>',agendaDetails.agendaDetails[0].PreambleAndResolution_FileName);
            this.agendaAddForm.controls.image.setValue(agendaDetails.agendaDetails[0].PreambleAndResolution_FileName);
            if (agendaDetails.agendaDetails[0].PreambleAndResolution_FileName == "" || agendaDetails.agendaDetails[0].PreambleAndResolution_FileName == undefined || agendaDetails.agendaDetails[0].PreambleAndResolution_FileName == 'File Not Available') {
              this.imageAdd = true;
              this.imageAddRev = false;
              // this.imageAddRev=true;
              this.imageEdit = false;
              this.typeHasError = false;
            }
            this.groupName = agendaDetails.agendaDetails[0].groupName;
            this.groupNumber = agendaDetails.agendaDetails[0].groupNumber;
            this.preambleFileUpdateDate = agendaDetails.agendaDetails[0].preambleFileUpdateDate;
            this.minuteFileUpdateDate = agendaDetails.agendaDetails[0].minuteFileUpdateDate;
            // console.log(agendaDetails.agendaDetails[0].MinuteDocument_fileName)
            if (agendaDetails.agendaDetails[0].MinuteDocument_fileName == "File Not Available" || agendaDetails.agendaDetails[0].MinuteDocument_fileName == "" || agendaDetails.agendaDetails[0].MinuteDocument_fileName == undefined || agendaDetails.agendaDetails[0].MinuteDocument_fileName == null) {
              this.minuteDocAdd = true;
              this.minuteDocAddRev = false;
              this.minuteDocEdit = false;
              this.typeHasError1 = false;
            }


            this.filenamedit = agendaDetails.agendaDetails[0].PreambleAndResolution_FileName;
            this.filenameoriginal = agendaDetails.agendaDetails[0].orinalFile;

            this.previousAgendafilename = agendaDetails.agendaDetails[0].PreambleAndResolution_FileName;
            this.previousAgendafileoriginal = agendaDetails.agendaDetails[0].orinalFile;

            this.TotalFile = new Array();
            this.TotalFileMinDoc = new Array();
            this.documentsDownload = new Array();
            this.actualFileName = new Array();
            if (agendaDetails.agendaDetails[0].PreambleAndResolution_FileName != null && agendaDetails.agendaDetails[0].PreambleAndResolution_FileName != undefined && agendaDetails.agendaDetails[0].PreambleAndResolution_FileName != 'undefined') {
              this.documentsDownload = agendaDetails.agendaDetails[0].PreambleAndResolution_FileName.split(',');
            }

            if (agendaDetails.agendaDetails[0].orinalFile) {
              this.actualFileName = agendaDetails.agendaDetails[0].orinalFile.split(',');
            }
            for (var i = 0; i < this.documentsDownload.length; i++) {
              this.documentsDownload[i] = this.documentsDownload[i];
              this.TotalFile[i] = { srno: i, FileChangedName: this.documentsDownload[i], actualFileName: this.actualFileName[i] };
            }

            this.documentsDownloadMinute = new Array();
            if (agendaDetails.agendaDetails[0].MinuteDocument_fileName != null && agendaDetails.agendaDetails[0].MinuteDocument_fileName != undefined && agendaDetails.agendaDetails[0].MinuteDocument_fileName != "") {
              this.documentsDownloadMinute = agendaDetails.agendaDetails[0].MinuteDocument_fileName.split(',');
            }

            this.minFilenamedit = agendaDetails.agendaDetails[0].MinuteDocument_fileName;
            this.Minutes_DocId = agendaDetails.agendaDetails[0].MinuteDocument_DocId;
            // this.minFilenameoriginal = agendaDetails.agendaDetails[0].orinalFile;
            for (var i = 0; i < this.documentsDownloadMinute.length; i++) {
              this.documentsDownloadMinute[i] = this.documentsDownloadMinute[i];
              this.TotalFileMinDoc[i] = { srno: i, FileChangedName: this.documentsDownloadMinute[i], actualFileName: this.actualFileName[i] };
            }

          }

        })
        this.dtTriggerForAddedTask.next()

      }
    })






  }

  booleanMeetingValidate: boolean;
  booleanCategoryValidate: boolean;

  addAgenda() {
    this.agendaFiles = [];
    var agendaNumber = this.agendaAddForm.controls.agendaNumber.value;
    var IscategorySelected = this.agendaAddForm.controls.IscategorySelected.value;//added Field
    var IsMeetingAssigned = this.agendaAddForm.controls.IsMeetingAssigned.value;//added Field
    var meetingType = this.agendaAddForm.controls.meetingType.value;
    var selectCategory = this.agendaAddForm.controls.selectCategory.value;//Modified added field
    var meeting = this.agendaAddForm.controls.meeting.value;// added field
    var agendaTitle = this.agendaAddForm.controls.agendaTitle.value;
    var department = this.agendaAddForm.controls.department.value == "null" ? null : this.agendaAddForm.controls.department.value;
    var agendaTypeSelection = this.agendaAddForm.controls.agendaType.value
    // var agendaCompliance = this.agendaAddForm.controls.agendaCompliance.value;
    var agendaCompliance = this.agendaAddedTaskList;
    var image = this.agendaAddForm.controls.image.value;
    var libaryType;
    var agendaType;

    var indexGrouping_id = this.agendaAddForm.controls.indexGrouping_id.value;


    if (IscategorySelected == 'No') {
      libaryType = 'Non-Library';
      this.agendaAddForm.controls.selectCategory.setValue("null"); selectCategory = null;
    }
    if (IsMeetingAssigned == 'No') {
      agendaType = 'Open';
      this.agendaAddForm.controls.meeting.setValue("null"); meeting = null;
    }
    if (IscategorySelected == 'Yes') { libaryType = 'Library'; }
    if (IsMeetingAssigned == 'Yes') { agendaType = 'Non-Open'; }

    if ((IsMeetingAssigned == 'Yes' && (meeting == null || meeting == "null")) || (IscategorySelected == 'Yes' && (selectCategory == null || selectCategory == "null"))) {

      if (IscategorySelected == 'Yes' && (selectCategory == null || selectCategory == "null")) {
        this.booleanCategoryValidate = true;

      } else {
        this.booleanCategoryValidate = false;
      }
      if ((IsMeetingAssigned == 'Yes' && (meeting == null || meeting == "null"))) {
        this.booleanMeetingValidate = true;

      } else {
        this.booleanMeetingValidate = false;
      }

      return false;
    }

    // if (agendaNumber == "" || agendaNumber == null) {
    //   this.agendaAddForm.controls.agendaNumber.setValue("null");
    // }

    // console.log('1> meetingType', meetingType); console.log('2> IsMeetingAssigned', IsMeetingAssigned); console.log('3>selected Meeting', meeting);
    // console.log('4>IscategorySelected', IscategorySelected); console.log('5>selected Category', selectCategory);

    this.isClickedOnce = true;
    this.upload(agendaTitle, this.agendaAddForm.controls.meetingType.value);
    this.uploadMinuteDcoument(agendaTitle, this.agendaAddForm.controls.meetingType.value);

    if (this.documentArr.length > 0 && this.documentArrMinDoc.length > 0) {
      var date = new Date();
      this.preambleFileUpdateDate = date;
      this.minuteFileUpdateDate = date;
      this.agendaService.updateAgendaDocumentInDB(this.documentArr).subscribe(documentData => {
        for (var index = 0; index < documentData.Data.length; index++) {
          var obj = { 'FileName': documentData.Data[index].Filename, 'DocumentManagementID': documentData.Data[index]._id }
          this.agendaFiles.push(obj);
        }

        this.agendaService.updateAgendaDocumentInDB(this.documentArrMinDoc).subscribe(documentDataMinDoc => {
          for (var index = 0; index < documentDataMinDoc.Data.length; index++) {
            var obj = { 'FileName': documentDataMinDoc.Data[index].Filename, 'DocumentManagementID': documentDataMinDoc.Data[index]._id }
            this.MinDocFiles.push(obj);
          }

          var varagendaCompliance = $('.select2').val();
          this.agendaAddForm.controls.agendaCompliance.setValue(varagendaCompliance);
          this.agendaAddForm.controls.image.setValue(this.changedName);
          var newAgenda = {
            agendaNumber: this.agendaAddForm.controls.agendaNumber.value,
            meetingType: this.agendaAddForm.controls.meetingType.value,
            selectCategory: this.agendaAddForm.controls.selectCategory.value,
            agendaTitle: this.agendaAddForm.controls.agendaTitle.value,
            agendaCompliance: this.agendaAddedTaskList,
            processes: this.addedProcess,
            IscategorySelected: IscategorySelected,
            IsMeetingAssigned: IsMeetingAssigned,
            meetingID: meeting,
            libaryType: libaryType,
            agendaType: agendaType,
            agendaTypeSelection: this.agendaAddForm.controls.agendaType.value,
            department: this.agendaAddForm.controls.department.value == "null" ? null : this.agendaAddForm.controls.department.value,
            orinalFile: this.FileNameOrignalDisplay,
            Upload: this.FileChangedName,
            image: this.agendaAddForm.controls.image.value,
            CreatedBy: '',
            CreatedDate: new Date(),
            ModifiedBy: '',
            ModifiedDate: '',
            AgendaFiles: this.agendaFiles,
            MinDocFiles: this.MinDocFiles,
            agendaNumberPrefix: this.agendaAddForm.controls.agendaNumberPrefix.value,
            PreambleAndResolution_DocId: documentData.Data[0]._id,
            MinuteDocument_DocId: documentDataMinDoc.Data[0]._id,
            MinuteDocument_fileName: this.FileChangedNameMinDoc,
            indexGrouping_id: indexGrouping_id,
            groupName: this.groupName,
            groupNumber: this.groupNumber,
            preambleFileUpdateDate: this.preambleFileUpdateDate,
            minuteFileUpdateDate: this.minuteFileUpdateDate,
            documentType: 'AgendaMinute'
          }
          this.loading = true;
          this.agendaService.addAgenda(newAgenda).subscribe(agenda => {
            if (agenda.status == 0) {
              this.loading = false;
              if (this.FromMeetingmeetingID != undefined || this.FromMeetingmeetingID != null) {
                console.log(agenda.message)
                this.alert.successWithOk1(agenda.message, ()=>{this.router.navigate(
                  [{ outlets: { 'structure-outlet': ['addMeetings', 'edit', this.FromMeetingmeetingID, 'Agenda'] } }],
                  { relativeTo: this.route.parent });});
              } else {
                this.alert.successWithOk1(agenda.message, ()=>{this.router.navigate(
                  [{ outlets: { 'structure-outlet': ['agenda'] } }],
                  { relativeTo: this.route.parent });});
              }
            }
            else if (agenda.status == 55) {
              this.loading = false;
              this.meetingService.downloadSplitFailureFile(agenda.filename);
              if (this.FromMeetingmeetingID != undefined || this.FromMeetingmeetingID != null) {
                this.alert.error(agenda.message);
                //this.alert.successWithOk(agenda.message, '/meeting/edit/' + this.FromMeetingmeetingID + '/Agenda');
              } else {
                this.alert.error(agenda.message);
                //this.alert.successWithOk(agenda.message, '/agenda')
              }
            }
            else {
              this.loading = false;
              this.alert.error(agenda.message);
            }
          });
        })
      });
    } else if (this.documentArr.length > 0) {
      this.preambleFileUpdateDate = new Date();
      this.agendaService.updateAgendaDocumentInDB(this.documentArr).subscribe(documentData => {
        for (var index = 0; index < documentData.Data.length; index++) {
          var obj = { 'FileName': documentData.Data[index].Filename, 'DocumentManagementID': documentData.Data[index]._id }
          this.agendaFiles.push(obj);
        }

        var varagendaCompliance = $('.select2').val();
        this.agendaAddForm.controls.agendaCompliance.setValue(varagendaCompliance);
        this.agendaAddForm.controls.image.setValue(this.changedName);
        var newAgenda = {
          agendaNumber: this.agendaAddForm.controls.agendaNumber.value,
          meetingType: this.agendaAddForm.controls.meetingType.value,
          selectCategory: this.agendaAddForm.controls.selectCategory.value,
          agendaTitle: this.agendaAddForm.controls.agendaTitle.value,
          agendaCompliance: this.agendaAddedTaskList,
          processes: this.addedProcess,
          IscategorySelected: IscategorySelected,
          IsMeetingAssigned: IsMeetingAssigned,
          meetingID: meeting,
          libaryType: libaryType,
          agendaType: agendaType,
          agendaTypeSelection: this.agendaAddForm.controls.agendaType.value,
          department: this.agendaAddForm.controls.department.value == "null" ? null : this.agendaAddForm.controls.department.value,
          orinalFile: this.FileNameOrignalDisplay,
          Upload: this.FileChangedName,
          image: this.agendaAddForm.controls.image.value,
          CreatedBy: '',
          CreatedDate: new Date(),
          ModifiedBy: '',
          ModifiedDate: '',
          AgendaFiles: this.agendaFiles,

          agendaNumberPrefix: this.agendaAddForm.controls.agendaNumberPrefix.value,
          PreambleAndResolution_DocId: documentData.Data[0]._id,
          indexGrouping_id: indexGrouping_id,
          groupName: this.groupName,
          groupNumber: this.groupNumber,
          preambleFileUpdateDate: this.preambleFileUpdateDate,
          minuteFileUpdateDate: this.minuteFileUpdateDate,
          documentType: 'Agenda'
        }
        // console.log('newAgenda------------', newAgenda);
        this.loading = true;
        this.agendaService.addAgenda(newAgenda).subscribe(agenda => {
          if (agenda.status == 0) {
            this.loading = false;
            if (this.FromMeetingmeetingID != undefined || this.FromMeetingmeetingID != null) {
              console.log(agenda.message)

              this.alert.successWithOk1(agenda.message, ()=>{this.router.navigate(
                [{ outlets: { 'structure-outlet': ['addMeetings', 'edit', this.FromMeetingmeetingID, 'Agenda'] } }],
                { relativeTo: this.route.parent });});
            } else {
              this.alert.successWithOk1(agenda.message, ()=>{this.router.navigate(
                [{ outlets: { 'structure-outlet': ['agenda'] } }],
                { relativeTo: this.route.parent });});
            }
          } else if (agenda.status == 55) {
            this.loading = false;
            this.meetingService.downloadSplitFailureFile(agenda.filename);
            if (this.FromMeetingmeetingID != undefined || this.FromMeetingmeetingID != null) {
              this.alert.error(agenda.message);
              //this.alert.successWithOk(agenda.message, '/meeting/edit/' + this.FromMeetingmeetingID + '/Agenda');
            } else {
              this.alert.error(agenda.message);
              //this.alert.successWithOk(agenda.message, '/agenda')
            }
          }
          else {
            this.loading = false;
            this.alert.error(agenda.message);
          }
        });
      })


    } else if (this.documentArrMinDoc.length > 0) {
      this.minuteFileUpdateDate = new Date();
      this.agendaService.updateAgendaDocumentInDB(this.documentArrMinDoc).subscribe(documentDataMinDoc => {
        for (var index = 0; index < documentDataMinDoc.Data.length; index++) {
          var obj = { 'FileName': documentDataMinDoc.Data[index].Filename, 'DocumentManagementID': documentDataMinDoc.Data[index]._id }
          this.MinDocFiles.push(obj);
        }

        var varagendaCompliance = $('.select2').val();
        this.agendaAddForm.controls.agendaCompliance.setValue(varagendaCompliance);
        this.agendaAddForm.controls.image.setValue(this.changedName);
        var newAgenda = {
          agendaNumber: this.agendaAddForm.controls.agendaNumber.value,
          meetingType: this.agendaAddForm.controls.meetingType.value,
          selectCategory: this.agendaAddForm.controls.selectCategory.value,
          agendaTitle: this.agendaAddForm.controls.agendaTitle.value,
          agendaCompliance: this.agendaAddedTaskList,
          processes: this.addedProcess,
          IscategorySelected: IscategorySelected,
          IsMeetingAssigned: IsMeetingAssigned,
          meetingID: meeting,
          libaryType: libaryType,
          agendaType: agendaType,
          agendaTypeSelection: this.agendaAddForm.controls.agendaType.value,
          department: this.agendaAddForm.controls.department.value == "null" ? null : this.agendaAddForm.controls.department.value,
          orinalFile: this.FileNameOrignalDisplay,
          Upload: this.FileChangedName,
          image: this.agendaAddForm.controls.image.value,
          CreatedBy: '',
          CreatedDate: new Date(),
          ModifiedBy: '',
          ModifiedDate: '',
          AgendaFiles: this.agendaFiles,
          MinDocFiles: this.MinDocFiles,
          agendaNumberPrefix: this.agendaAddForm.controls.agendaNumberPrefix.value,
          MinuteDocument_DocId: documentDataMinDoc.Data[0]._id,
          MinuteDocument_fileName: this.FileChangedNameMinDoc,
          indexGrouping_id: indexGrouping_id,
          groupName: this.groupName,
          groupNumber: this.groupNumber,
          preambleFileUpdateDate: this.preambleFileUpdateDate,
          minuteFileUpdateDate: this.minuteFileUpdateDate,
          documentType: 'Minute'
        }
        // console.log('newAgenda------------', newAgenda);
        this.loading = true;
        this.agendaService.addAgenda(newAgenda).subscribe(agenda => {
          if (agenda.status == 0) {
            this.loading = false;
            if (this.FromMeetingmeetingID != undefined || this.FromMeetingmeetingID != null) {
              this.alert.successWithOk1(agenda.message, ()=>{this.router.navigate(
                [{ outlets: { 'structure-outlet': ['addMeetings', 'edit', this.FromMeetingmeetingID, 'Agenda'] } }],
                { relativeTo: this.route.parent });});
            } else {
              this.alert.successWithOk1(agenda.message, ()=>{this.router.navigate(
                [{ outlets: { 'structure-outlet': ['agenda'] } }],
                { relativeTo: this.route.parent });});
            }
          } else if (agenda.status == 55) {
            this.loading = false;
            this.meetingService.downloadSplitFailureFile(agenda.filename);
            if (this.FromMeetingmeetingID != undefined || this.FromMeetingmeetingID != null) {
              this.alert.error(agenda.message);
              //this.alert.successWithOk(agenda.message, '/meeting/edit/' + this.FromMeetingmeetingID + '/Agenda');
            } else {
              this.alert.error(agenda.message);
              //this.alert.successWithOk(agenda.message, '/agenda')
            }
          }
          else {
            this.loading = false;
            this.alert.error(agenda.message);
          }
        });
      });


    } else {
      var varagendaCompliance = $('.select2').val();
      this.agendaAddForm.controls.agendaCompliance.setValue(varagendaCompliance);
      this.agendaAddForm.controls.image.setValue(this.changedName);
      var newAgenda = {
        agendaNumber: this.agendaAddForm.controls.agendaNumber.value,
        meetingType: this.agendaAddForm.controls.meetingType.value,
        selectCategory: this.agendaAddForm.controls.selectCategory.value,
        agendaTitle: this.agendaAddForm.controls.agendaTitle.value,
        agendaCompliance: this.agendaAddedTaskList,
        processes: this.addedProcess,
        IscategorySelected: IscategorySelected,
        IsMeetingAssigned: IsMeetingAssigned,
        meetingID: meeting,
        libaryType: libaryType,
        agendaType: agendaType,
        agendaTypeSelection: this.agendaAddForm.controls.agendaType.value,
        department: this.agendaAddForm.controls.department.value == "null" ? null : this.agendaAddForm.controls.department.value,
        orinalFile: this.FileNameOrignalDisplay,
        Upload: this.FileChangedName,
        image: this.agendaAddForm.controls.image.value,
        CreatedBy: '',
        CreatedDate: new Date(),
        ModifiedBy: '',
        ModifiedDate: '',
        AgendaFiles: this.agendaFiles,
        agendaNumberPrefix: this.agendaAddForm.controls.agendaNumberPrefix.value,
        indexGrouping_id: indexGrouping_id,
        groupName: this.groupName,
        groupNumber: this.groupNumber,
        preambleFileUpdateDate: this.preambleFileUpdateDate,
        minuteFileUpdateDate: this.minuteFileUpdateDate,
        documentType: 'None'
      }
      // console.log('newAgenda------------', newAgenda);
      this.loading = true;
      this.agendaService.addAgenda(newAgenda).subscribe(agenda => {
        if (agenda.status == 0) {
          this.loading = false;
          if (this.FromMeetingmeetingID != undefined || this.FromMeetingmeetingID != null) {
            this.alert.successWithOk1(agenda.message, ()=>{this.router.navigate(
              [{ outlets: { 'structure-outlet': ['addMeetings', 'edit', this.FromMeetingmeetingID, 'Agenda'] } }],
              { relativeTo: this.route.parent });});
          } else {
            this.alert.successWithOk1(agenda.message, ()=>{this.router.navigate(
              [{ outlets: { 'structure-outlet': ['agenda'] } }],
              { relativeTo: this.route.parent });});
          }
        }
        else {
          this.loading = false;
          this.alert.error(agenda.message);
        }
      });
    }



  }

  updateAgenda() {
    // console.log(this.agendaAddForm.controls.agendaType.value);
    this.agendaAddedTaskList = this.agendaAddedTaskList.concat(this.hideCompliance);
    var varagendaCompliance = $('.select2').val();
    // alert(varagendaCompliance);
    //console.log('file name--->',this.agendaAddForm.controls.image.value);

    this.isClickedOnce = true;
    this.agendaAddForm.controls.agendaCompliance.setValue(varagendaCompliance);
    var agendaNumber = this.agendaAddForm.controls.agendaNumber.value;
    var IscategorySelected = this.agendaAddForm.controls.IscategorySelected.value;//added Field
    var IsMeetingAssigned = this.agendaAddForm.controls.IsMeetingAssigned.value;//added Field
    var meetingType = this.agendaAddForm.controls.meetingType.value;
    var selectCategory = this.agendaAddForm.controls.selectCategory.value;//Modified added field
    var meeting = this.agendaAddForm.controls.meeting.value;// added field
    var agendaTitle = this.agendaAddForm.controls.agendaTitle.value;
    var agendaCompliance = this.agendaAddedTaskList;
    var image = this.agendaAddForm.controls.image.value;
    var indexGrouping_id = this.agendaAddForm.controls.indexGrouping_id.value;

    var libaryType;
    var agendaType;
    if (IscategorySelected == 'No') { libaryType = 'Non-Library'; this.agendaAddForm.controls.selectCategory.setValue("null"); selectCategory = null; }
    if (IsMeetingAssigned == 'No') { agendaType = 'Open'; this.agendaAddForm.controls.meeting.setValue("null"); meeting = null; }
    if (IscategorySelected == 'Yes') { libaryType = 'Library'; }
    if (IsMeetingAssigned == 'Yes') { agendaType = 'Non-Open'; }


    if ((IsMeetingAssigned == 'Yes' && (meeting == null || meeting == "null")) || (IscategorySelected == 'Yes' && (selectCategory == null || selectCategory == "null"))) {

      if (IscategorySelected == 'Yes' && (selectCategory == null || selectCategory == "null")) {
        this.booleanCategoryValidate = true;

      } else {
        this.booleanCategoryValidate = false;
      }
      if ((IsMeetingAssigned == 'Yes' && (meeting == null || meeting == "null"))) {
        this.booleanMeetingValidate = true;

      } else {
        this.booleanMeetingValidate = false;
      }

      return false;
    }

    this.agendaDisabledOnclick = true;

    if (this.imageAdd || this.minuteDocAdd) {
      this.upload(this.agendaAddForm.controls.agendaTitle.value, this.agendaAddForm.controls.meetingType.value);
      this.uploadMinuteDcoument(this.agendaAddForm.controls.agendaTitle.value, this.agendaAddForm.controls.meetingType.value);
      if (this.AddNewAgendafiles) {

        this.FileNameOrignalDisplay.push(this.previousAgendafileoriginal);

        this.FileChangedName.push(this.previousAgendafilename);

      }
      this.agendaAddForm.controls.image.setValue(this.changedName);
      if (this.documentArr.length > 0 && this.documentArrMinDoc.length > 0) {
        var date = new Date();
        this.preambleFileUpdateDate = date;
        this.minuteFileUpdateDate = date;
        // console.log('test-------2222222')
        this.agendaService.updateAgendaDocumentInDB(this.documentArr).subscribe(documentData => {
          // console.log(documentData);
          // console.log(documentData.Data.Filename);
          // console.log(documentData.Data._id);
          for (var index = 0; index < documentData.Data.length; index++) {
            var obj = { 'FileName': documentData.Data[index].Filename, 'DocumentManagementID': documentData.Data[index]._id }
            this.agendaFiles.push(obj);
          }

          this.agendaService.updateAgendaDocumentInDB(this.documentArrMinDoc).subscribe(documentDataMinDoc => {
            for (var index = 0; index < documentDataMinDoc.Data.length; index++) {
              var obj = { 'FileName': documentDataMinDoc.Data[index].Filename, 'DocumentManagementID': documentDataMinDoc.Data[index]._id }
              this.MinDocFiles.push(obj);
            }


            this.PreambleAndResolution_DocId = documentData.Data[0]._id;
            var newAgenda = {
              _id: this.agendaId,
              agendaNumber: this.agendaAddForm.controls.agendaNumber.value,
              meetingType: this.agendaAddForm.controls.meetingType.value,
              selectCategory: this.agendaAddForm.controls.selectCategory.value,
              agendaTitle: this.agendaAddForm.controls.agendaTitle.value,
              // name : new FormControl('',[]),
              processes: this.addedProcess,
              IscategorySelected: IscategorySelected,
              IsMeetingAssigned: IsMeetingAssigned,
              meetingID: meeting,
              libaryType: libaryType,
              agendaType: agendaType,
              isChangeToMeeting: this.isChangeToMeeting,
              agendaCompliance: this.agendaAddedTaskList,
              image: this.agendaAddForm.controls.image.value,
              agendaTypeSelection: this.agendaAddForm.controls.agendaType.value,
              department: this.agendaAddForm.controls.department.value == "null" ? null : this.agendaAddForm.controls.department.value,
              orinalFile: this.FileNameOrignalDisplay,
              Upload: this.FileChangedName,
              deletedProcesses: this.deletedProcesses,
              deletedTasks: this.deletedTasks,
              CreatedBy: '',
              CreatedDate: new Date(),
              ModifiedBy: '',
              ModifiedDate: '',
              AgendaFiles: this.agendaFiles,
              agendaNumberPrefix: this.agendaAddForm.controls.agendaNumberPrefix.value,
              PreambleAndResolution_DocId: this.PreambleAndResolution_DocId,
              MinDocFiles: this.MinDocFiles,
              MinuteDocument_DocId: documentDataMinDoc.Data[0]._id,
              MinuteDocument_fileName: this.FileChangedNameMinDoc,
              indexGrouping_id: indexGrouping_id,
              groupName: this.groupName,
              groupNumber: this.groupNumber,
              preambleFileUpdateDate: this.preambleFileUpdateDate,
              minuteFileUpdateDate: this.minuteFileUpdateDate,
              documentType: 'AgendaMinute'
              // AddNewAgendafiles:this.AddNewAgendafiles
            }

            this.loading = true;
            this.agendaService.updateAgenda(newAgenda).subscribe(agenda => {

              if (agenda.status == 0) {
                this.loading = false;
                var fromMeeting = localStorage.getItem('fromMeeting')
                // localStorage.removeItem('fromMeeting');
                if (fromMeeting != undefined || fromMeeting != null) {
                  this.alert.successWithOk1(agenda.message, ()=>{this.router.navigate(
                    [{ outlets: { 'structure-outlet': ['addMeetings', 'edit',fromMeeting, 'Agenda'] } }],
                    { relativeTo: this.route.parent });});
                } else {
                  this.alert.successWithOk1(agenda.message, ()=>{this.router.navigate(
                    [{ outlets: { 'structure-outlet': ['agenda'] } }],
                    { relativeTo: this.route.parent });});
                }
                //this.alert.successWithOk(agenda.message, '/agenda')
              } else if (agenda.status == 55) {
                this.loading = false;
                var fromMeeting = localStorage.getItem('fromMeeting')
                this.meetingService.downloadSplitFailureFile(agenda.filename);
                // localStorage.removeItem('fromMeeting');
                if (fromMeeting != undefined || fromMeeting != null) {
                  this.alert.error(agenda.message);
                  //this.alert.successWithOk(agenda.message, '/meeting/edit/' + fromMeeting + '/Agenda');
                } else {
                  this.alert.error(agenda.message);
                  //this.alert.successWithOk(agenda.message, '/agenda')
                }
              }
              else {
                this.loading = false;
                this.alert.error(agenda.message);
              }
            });

          })
        });
      }
      else if (this.documentArr.length > 0) {
        this.preambleFileUpdateDate = new Date();
        this.agendaService.updateAgendaDocumentInDB(this.documentArr).subscribe(documentData => {
          for (var index = 0; index < documentData.Data.length; index++) {
            var obj = { 'FileName': documentData.Data[index].Filename, 'DocumentManagementID': documentData.Data[index]._id }
            this.agendaFiles.push(obj);
          }

          // console.log(this.agendaFiles)
          var varagendaCompliance = $('.select2').val();
          this.agendaAddForm.controls.agendaCompliance.setValue(varagendaCompliance);
          this.agendaAddForm.controls.image.setValue(this.changedName);
          var newAgenda = {
            _id: this.agendaId,
            agendaNumber: this.agendaAddForm.controls.agendaNumber.value,
            meetingType: this.agendaAddForm.controls.meetingType.value,
            selectCategory: this.agendaAddForm.controls.selectCategory.value,
            agendaTitle: this.agendaAddForm.controls.agendaTitle.value,
            agendaCompliance: this.agendaAddedTaskList,
            processes: this.addedProcess,
            IscategorySelected: IscategorySelected,
            IsMeetingAssigned: IsMeetingAssigned,
            meetingID: meeting,
            libaryType: libaryType,
            agendaType: agendaType,
            agendaTypeSelection: this.agendaAddForm.controls.agendaType.value,
            department: this.agendaAddForm.controls.department.value == "null" ? null : this.agendaAddForm.controls.department.value,
            orinalFile: this.FileNameOrignalDisplay,
            Upload: this.FileChangedName,
            image: this.agendaAddForm.controls.image.value,
            CreatedBy: '',
            CreatedDate: new Date(),
            ModifiedBy: '',
            ModifiedDate: '',
            AgendaFiles: this.agendaFiles,

            agendaNumberPrefix: this.agendaAddForm.controls.agendaNumberPrefix.value,
            PreambleAndResolution_DocId: documentData.Data[0]._id,
            indexGrouping_id: indexGrouping_id,
            groupName: this.groupName,
            groupNumber: this.groupNumber,
            MinuteDocument_DocId: this.Minutes_DocId,
            MinuteDocument_fileName: [this.minFilenamedit],
            preambleFileUpdateDate: this.preambleFileUpdateDate,
            minuteFileUpdateDate: this.minuteFileUpdateDate,
            documentType: 'Agenda'
          }
         this.loading = true;
          this.agendaService.updateAgenda(newAgenda).subscribe(agenda => {
            this.agendaDisabledOnclick = false;
            if (agenda.status == 0) {
              this.loading = false;
              if (this.FromMeetingmeetingID != undefined || this.FromMeetingmeetingID != null) {
                this.alert.successWithOk1(agenda.message, ()=>{this.router.navigate(
                  [{ outlets: { 'structure-outlet': ['addMeetings', 'edit', this.FromMeetingmeetingID, 'Agenda'] } }],
                  { relativeTo: this.route.parent });});
              } else {
                this.alert.successWithOk1(agenda.message, ()=>{this.router.navigate(
                  [{ outlets: { 'structure-outlet': ['agenda'] } }],
                  { relativeTo: this.route.parent });});
              }
            } else if (agenda.status == 55) {
              this.loading = false;
              var fromMeeting = localStorage.getItem('fromMeeting')
              this.meetingService.downloadSplitFailureFile(agenda.filename);
              // localStorage.removeItem('fromMeeting');
              if (fromMeeting != undefined || fromMeeting != null) {
                this.alert.error(agenda.message);
                //this.alert.successWithOk(agenda.message, '/meeting/edit/' + fromMeeting + '/Agenda');
              } else {
                this.alert.error(agenda.message);
                //this.alert.successWithOk(agenda.message, '/agenda')
              }
            }
            else {
              this.loading = false;
              this.alert.error(agenda.message);
            }
          });
        })

      } else if (this.documentArrMinDoc.length > 0) {
        this.minuteFileUpdateDate = new Date();
        this.agendaService.updateAgendaDocumentInDB(this.documentArrMinDoc).subscribe(documentDataMinDoc => {
          for (var index = 0; index < documentDataMinDoc.Data.length; index++) {
            var obj = { 'FileName': documentDataMinDoc.Data[index].Filename, 'DocumentManagementID': documentDataMinDoc.Data[index]._id }
            this.MinDocFiles.push(obj);
          }

          // console.log(this.agendaFiles)
          var varagendaCompliance = $('.select2').val();
          this.agendaAddForm.controls.agendaCompliance.setValue(varagendaCompliance);
          this.agendaAddForm.controls.image.setValue(this.changedName);
          this.FileNameOrignalDisplay = this.filenameoriginal;
          this.FileChangedName = this.filenamedit;
          var newAgenda = {
            _id: this.agendaId,
            agendaNumber: this.agendaAddForm.controls.agendaNumber.value,
            meetingType: this.agendaAddForm.controls.meetingType.value,
            selectCategory: this.agendaAddForm.controls.selectCategory.value,
            agendaTitle: this.agendaAddForm.controls.agendaTitle.value,
            agendaCompliance: this.agendaAddedTaskList,
            processes: this.addedProcess,
            IscategorySelected: IscategorySelected,
            IsMeetingAssigned: IsMeetingAssigned,
            meetingID: meeting,
            libaryType: libaryType,
            agendaType: agendaType,
            agendaTypeSelection: this.agendaAddForm.controls.agendaType.value,
            department: this.agendaAddForm.controls.department.value == "null" ? null : this.agendaAddForm.controls.department.value,
            orinalFile: this.FileNameOrignalDisplay,
            Upload: this.FileChangedName,
            image: this.agendaAddForm.controls.image.value,
            CreatedBy: '',
            CreatedDate: new Date(),
            ModifiedBy: '',
            ModifiedDate: '',
            AgendaFiles: this.agendaFiles,
            MinDocFiles: this.MinDocFiles,
            agendaNumberPrefix: this.agendaAddForm.controls.agendaNumberPrefix.value,
            PreambleAndResolution_DocId: this.PreambleAndResolution_DocId,
            MinuteDocument_DocId: documentDataMinDoc.Data[0]._id,
            MinuteDocument_fileName: this.FileChangedNameMinDoc,
            indexGrouping_id: indexGrouping_id,
            groupName: this.groupName,
            groupNumber: this.groupNumber,
            preambleFileUpdateDate: this.preambleFileUpdateDate,
            minuteFileUpdateDate: this.minuteFileUpdateDate,
            documentType: 'Minute'
          }
          // console.log('newAgenda------------', newAgenda);
          this.loading = true;
          
          this.agendaService.updateAgenda(newAgenda).subscribe(agenda => {
            if (agenda.status == 0) {
              this.loading = false;
              if (this.FromMeetingmeetingID != undefined || this.FromMeetingmeetingID != null) {
                this.alert.successWithOk1(agenda.message, ()=>{this.router.navigate(
                  [{ outlets: { 'structure-outlet': ['addMeetings', 'edit', this.FromMeetingmeetingID, 'Agenda'] } }],
                  { relativeTo: this.route.parent });});
              } else {
                this.alert.successWithOk1(agenda.message, ()=>{this.router.navigate(
                  [{ outlets: { 'structure-outlet': ['agenda'] } }],
                  { relativeTo: this.route.parent });});
              }
            } else if (agenda.status == 55) {
              this.loading = false;
              var fromMeeting = localStorage.getItem('fromMeeting')
              this.meetingService.downloadSplitFailureFile(agenda.filename);
              // localStorage.removeItem('fromMeeting');
              if (fromMeeting != undefined || fromMeeting != null) {
                this.alert.error(agenda.message);
                //this.alert.successWithOk(agenda.message, '/meeting/edit/' + fromMeeting + '/Agenda');
              } else {
                this.alert.error(agenda.message);
                //this.alert.successWithOk(agenda.message, '/agenda')
              }
            }
            else {
              this.loading = false;
              this.alert.error(agenda.message);
            }
          });
        });


      } else {
        this.FileNameOrignalDisplay = this.filenameoriginal;
        this.FileChangedName = this.filenamedit;
        var newAgenda = {
          _id: this.agendaId,
          agendaNumber: this.agendaAddForm.controls.agendaNumber.value,
          meetingType: this.agendaAddForm.controls.meetingType.value,
          selectCategory: this.agendaAddForm.controls.selectCategory.value,
          agendaTitle: this.agendaAddForm.controls.agendaTitle.value,
          // name : new FormControl('',[]),
          processes: this.addedProcess,
          IscategorySelected: IscategorySelected,
          IsMeetingAssigned: IsMeetingAssigned,
          meetingID: meeting,
          libaryType: libaryType,
          agendaType: agendaType,
          agendaTypeSelection: this.agendaAddForm.controls.agendaType.value,
          department: this.agendaAddForm.controls.department.value == "null" ? null : this.agendaAddForm.controls.department.value,
          isChangeToMeeting: this.isChangeToMeeting,
          agendaCompliance: this.agendaAddedTaskList,
          image: this.agendaAddForm.controls.image.value,
          orinalFile: this.FileNameOrignalDisplay,
          Upload: this.FileChangedName,
          deletedProcesses: this.deletedProcesses,
          deletedTasks: this.deletedTasks,
          CreatedBy: '',
          CreatedDate: new Date(),
          ModifiedBy: '',
          ModifiedDate: '',
          AgendaFiles: this.agendaFiles,
          agendaNumberPrefix: this.agendaAddForm.controls.agendaNumberPrefix.value,
          PreambleAndResolution_DocId: this.PreambleAndResolution_DocId,
          indexGrouping_id: indexGrouping_id,
          groupName: this.groupName,
          groupNumber: this.groupNumber,
          MinuteDocument_DocId: this.Minutes_DocId,
          MinuteDocument_fileName: [this.minFilenamedit],
          preambleFileUpdateDate: this.preambleFileUpdateDate,
          minuteFileUpdateDate: this.minuteFileUpdateDate,
          documentType: 'None'
          // AddNewAgendafiles:this.AddNewAgendafiles
        }

        // console.log('newAgenda-=------------', newAgenda);
        this.loading = true;
        this.agendaService.updateAgenda(newAgenda).subscribe(agenda => {

            if (agenda.status == 0) {
              this.loading = false;
              var fromMeeting = localStorage.getItem('fromMeeting')
              //this.meetingService.downloadSplitFailureFile(agenda.filename); //When Status is successful , error file need not be called.
              // localStorage.removeItem('fromMeeting');
              if (fromMeeting != undefined || fromMeeting != null) {
                this.alert.successWithOk1(agenda.message, ()=>{this.router.navigate(
                  [{ outlets: { 'structure-outlet': ['addMeetings', 'edit', fromMeeting, 'Agenda'] } }],
                  { relativeTo: this.route.parent });});
              } else {
                this.alert.successWithOk1(agenda.message, ()=>{this.router.navigate(
                  [{ outlets: { 'structure-outlet': ['agenda'] } }],
                  { relativeTo: this.route.parent });});
              }
            //this.alert.successWithOk(agenda.message, '/agenda')
          }
          else {
            this.loading = false;
            this.alert.error(agenda.message);
          }
        });
      }


    }
    else {
      this.FileNameOrignalDisplay = this.filenameoriginal;
      this.FileChangedName = this.filenamedit;

      var newAgenda = {
        _id: this.agendaId,
        agendaNumber: this.agendaAddForm.controls.agendaNumber.value,
        meetingType: this.agendaAddForm.controls.meetingType.value,
        selectCategory: this.agendaAddForm.controls.selectCategory.value,
        agendaTitle: this.agendaAddForm.controls.agendaTitle.value,
        // name : new FormControl('',[]),
        processes: this.addedProcess,
        IscategorySelected: IscategorySelected,
        IsMeetingAssigned: IsMeetingAssigned,
        meetingID: meeting,
        libaryType: libaryType,
        agendaType: agendaType,
        agendaTypeSelection: this.agendaAddForm.controls.agendaType.value,
        department: this.agendaAddForm.controls.department.value == "null" ? null : this.agendaAddForm.controls.department.value,
        isChangeToMeeting: this.isChangeToMeeting,
        agendaCompliance: this.agendaAddedTaskList,
        image: this.agendaAddForm.controls.image.value,
        orinalFile: this.FileNameOrignalDisplay,
        Upload: this.FileChangedName,
        deletedProcesses: this.deletedProcesses,
        deletedTasks: this.deletedTasks,
        CreatedBy: '',
        CreatedDate: new Date(),
        ModifiedBy: '',
        ModifiedDate: '',
        AgendaFiles: this.agendaFiles,
        agendaNumberPrefix: this.agendaAddForm.controls.agendaNumberPrefix.value,
        PreambleAndResolution_DocId: this.PreambleAndResolution_DocId,
        indexGrouping_id: indexGrouping_id,
        groupName: this.groupName,
        groupNumber: this.groupNumber,
        MinuteDocument_DocId: this.Minutes_DocId,
        MinuteDocument_fileName: [this.minFilenamedit],
        preambleFileUpdateDate: this.preambleFileUpdateDate,
        minuteFileUpdateDate: this.minuteFileUpdateDate,
        documentType: 'None'
        // AddNewAgendafiles:this.AddNewAgendafiles    
      }

      // console.log('newAgenda-=------------', newAgenda);
      this.loading = true;
      
      this.agendaService.updateAgenda(newAgenda).subscribe(agenda => {

        if (agenda.status == 0) {
          this.loading = false;
          var fromMeeting = localStorage.getItem('fromMeeting')
          // localStorage.removeItem('fromMeeting');
          if (fromMeeting != undefined || fromMeeting != null) {
            this.alert.successWithOk1(agenda.message, ()=>{this.router.navigate(
              [{ outlets: { 'structure-outlet': ['addMeetings', 'edit', fromMeeting, 'Agenda'] } }],
              { relativeTo: this.route.parent });});
          } else {
            this.alert.successWithOk1(agenda.message, ()=>{this.router.navigate(
              [{ outlets: { 'structure-outlet': ['agenda'] } }],
              { relativeTo: this.route.parent });});
          }
          //this.alert.successWithOk(agenda.message, '/agenda')
        }
        else {
          this.loading = false;
          this.alert.error(agenda.message);
        }
      });
    }
  }

  downloadDoc() {
    var token = localStorage.getItem('token')

    var lastSegOfURL = window.location.href.substr(window.location.href.lastIndexOf('/') + 1);

    // this.agendaService.downloadDOCS(lastSegOfURL).subscribe(data => {
    //   // var blob = new Blob([data]);
    // var url = window.URL.createObjectURL(blob);
    // console.log(data.url),
    window.open(this.downloadLink + lastSegOfURL + "/" + token);
    // }),//console.log(data),
    //   error => console.log("Error downloading the file."),
    //   () => console.info("OK");
  }

  downloadMinDoc() {
    var lastSegOfURL = window.location.href.substr(window.location.href.lastIndexOf('/') + 1);

    this.agendaService.downloadDocMin(lastSegOfURL).subscribe(data => {
      // var blob = new Blob([data]);
      // var url = window.URL.createObjectURL(blob);
      // console.log(data.url),
     ///////// //below are uncomment code
      // if(data && data.url){
      //   window.open(data.url);
      // }
     
    }),//console.log(data),
      error => console.log("Error downloading the file."),
      () => console.info("OK");
  }




  allFiles: any[];

  downloadAll() {
    var token = localStorage.getItem('token')

    var lastSegOfURL = window.location.href.substr(window.location.href.lastIndexOf('/') + 1);
    window.location.href = this.downloadAllLink + lastSegOfURL + "/" + token;
  }


  meetingDateOnSelectedType: any[];
  getMeetingFromType(meetingTypeId) {
    this.meetingTypeID = meetingTypeId;
    this.agendaAddForm.controls.meeting.setValue(null);
    this.agendaAddForm.controls.selectCategory.setValue(null);
    // console.log(meetingTypeId);
    this.agendaService.getMeetingOnTypeSelect(meetingTypeId).subscribe(data => {
      // console.log('data',data.meetingData)
      if (data.status == 0) {
        if (data.meetingData.length > 0) {
          //  this.meetingDateOnSelectedType = this.commonFunction.sortByKey(data.meetingData, 'MeetingDate');
          this.meetingDateOnSelectedType = data.meetingData;

        }
      } else {
        this.meetingDateOnSelectedType = []
        this.agendaAddForm.controls.meeting.setValue(null);
      }
    });
    this.processes = [];
    this.categories = [];
    // this.onAddProcessModelPopUpEvent();
    this.showAllProcesses()
    this.getCategoryListOnBehalfOfMeeting(meetingTypeId);
  }

  getCategoryListOnBehalfOfMeeting(meetingTypeId) {
    this.categories = [];
    this.categoryMasterService.getCategoryListByMeetingTypeID(meetingTypeId)
      .subscribe(categoryList => {
        if (categoryList.status == 0) {
          this.categories = this.commonFunction.sortByKey(categoryList.categoryList, 'CategoryName');
          let categorySelected = this.agendaAddForm.controls['selectCategory'].value;
          let isGlobalCategorySelected;
          isGlobalCategorySelected = _.find(this.categories, { _id: categorySelected, IsGlobal: true });
          if (isGlobalCategorySelected) {
            this.disableOnEdit = true;
            this.getMeetingNameById();
          } else {
            this.disableOnEdit = false;
          }
        }
      });
  }


  showAddPopUp() {
    $("#myModalLabel").html('<i class="fa fa-plus"></i>Add Category');
    // $("#myModalLabel").text("Add Category Master");
    $('#btnsaveCategory').show();
    $('#btnupdateCategory').hide();
    $('#isDefaultYes').prop("disabled", false);
    $('#isDefaultNo').prop("disabled", false);
    this.categoryMasterForm.controls.CategoryName.setValue('');
    this.categoryMasterForm.controls.MeetingType.setValue('');
    this.categoryMasterForm.controls.IsGlobal.setValue('Company');
    this.categoryMasterForm.controls.isDefault.setValue('false');
    // this.error = { isError: false, errorMessage: '' }
    setTimeout(function () {
      $(".radio").focus();
    }, 500);

  }

  showAddPopUpIndexGroup() {
    this.GroupingNumberTouched = false;
    this.GroupingNameTouched = false;
    $("#myModalLabel").html('<i class="fa fa-plus"></i>Add Category');
    // $("#myModalLabel").text("Add Category Master");
    $('#btnsaveCategory').show();
    $('#btnupdateCategory').hide();
    this.categoryMasterForm.controls.CategoryName.setValue('');
    this.categoryMasterForm.controls.MeetingType.setValue('');
    this.categoryMasterForm.controls.IsGlobal.setValue('Company');
    // this.error = { isError: false, errorMessage: '' }
    setTimeout(function () {
      $(".radio").focus();
    }, 500);

  }

  showAddPopUpAgendaType(){
    this.agendaNameFieldTouched = false;

  }


  addCategory() {
    this.categoryDisabledOnclick = true;
    if (this.categoryMasterForm.status == "VALID") {
      var checkGlobal = true;
      var checkDefault = true;
      if (this.categoryMasterForm.controls.IsGlobal.value == 'Company') {
        checkGlobal = false
      }
      if (this.categoryMasterForm.controls.isDefault.value == 'false') {
        checkDefault = false;
      }
      var newCategory = {
        IsGlobal: checkGlobal,
        isDefault: checkDefault,
        CategoryName: this.categoryMasterForm.controls.CategoryName.value.trim(),
        MeetingTypeID: this.categoryMasterForm.controls.MeetingType.value
        //CompanyID:"5a3778b4323b0a2a5839474b"
      }
      this.categoryMasterService.addCategory(newCategory)
        .subscribe(category => {
          this.categoryDisabledOnclick = false;
          if (category.status == 0) {
            $('#categoryDialog').modal('toggle');
            this.alert.success("Category created successfully.");
            this.getCategoryListOnBehalfOfMeeting(this.meetingTypeID);
            // this.getCategoryList();
          } else {
            $('#categoryDialog').modal('toggle');
            this.alert.error(category.message);
          }

          this.categoryMasterForm.reset();

        });
    }
    else {
      // console.log('Invalid form submit.')
      return false;
    }
  }

  regiserModalShowEvent() {
    $('#AddCompliancesDialog').on('shown.bs.modal', function (e) {
      $('#companytaskTable').DataTable().columns.adjust();
    })
  }

  meetingTypeID: any;
  processError = {
    message: "Please select Meeting Type First",
    hasError: true
  };

  onAddProcessModelPopUpEvent() {
    var meetingTypeID = this.meetingTypeID;
    if (meetingTypeID == undefined || meetingTypeID == undefined || meetingTypeID == null || meetingTypeID == "null") {
      this.processError.hasError = true;
      $("#processTableData").hide();
      this.processError.message = "Please select Meeting Type First"
      $("#processTablePopup").DataTable().destroy();
      this.processes = [];

      this.dtTriggerProcessAddingPopup.next();
    } else {
      // $("#processTablePopup").show();
      $("#processTablePopup").DataTable().destroy();
      this.processes = [];

      this.processError.hasError = false;
      this.processMasterService.getProcessList()
        .subscribe(data => {
          if (data.status == 0) {
            var data = data.processList;
            var processesData = [];
            data.forEach(element => {
              element.IsSelected = false;
              if (element.MeetingTypeId != meetingTypeID) {
                processesData.push(element);
              }
            });
            $("#processTablePopup").DataTable().destroy();
            this.processes = processesData;
            for (var j = 0; j < this.addedProcess.length; j++) {
              var index = this.indexOfElementArray(this.processes, this.addedProcess[j]);
              // console.log(index);
              this.processes.splice(index, 1);
            }
            this.dtTriggerProcessAddingPopup.next();
          }
        })
      // // $("processTablePopup").DataTable().destroy();

      // this.processMasterService.getProcessList()
      //   .subscribe(processList => {
      //     if (processList.status == 0) {
      //       var processData= processList.processList;

      //       processData.forEach(element => {
      //         element.IsSelected = false;
      //       //   var i = 0;
      //       //   if (element.MeetingTypeId == this.meetingTypeID) {

      //       //     this.processes.splice(i, 1);
      //       //     // console.log("Found meeting type ID");
      //       //     i++;
      //       //   }
      //       });
      //       $("#processTablePopup").DataTable().destroy();
      //      this. processes=[]
      //       console.log('process data---->>',processData);
      //       this.processes =processData;
      //       // for (var j = 0; j < this.addedProcess.length; j++) {
      //       //   var index = this.indexOfElementArray(this.processes, this.addedProcess[j]);
      //       //   // console.log(index);
      //       //   this.processes.splice(index, 1);
      //       // }

      //       // console.log(this.processes)
      //       // this.dtTriggerForAddedProcess.next();
      //       this.dtTriggerProcessAddingPopup.next();
      //     }
      //   })
    }
  }

  getProcessList() {
    // this.processes = [];

    // $("processTablePopup").DataTable().destroy();
    // this.processMasterService.getProcessList()
    //   .subscribe(processList => {
    //     if (processList.status == 0) {
    //       this.processes = processList.processList;
    //       this.processes.forEach(element => {
    //         element.IsSelected = false;
    //         if (element.MeetingTypeId == this.meetingTypeID) {
    //           // console.log("Found meeting type ID");
    //         }
    //       });
    //       // console.log(this.processes)
    //       // this.dtTriggerForAddedProcess.next();
    //       this.dtTriggerProcessAddingPopup.next();
    //     }
    //   })
    this.onAddProcessModelPopUpEvent()
  }

  indexOfElementArray(array: any[], elementValue) {
    var index = _.findIndex(array, function (o) {

      if (o._id == elementValue._id) { console.log('found element', o); }
      return o._id == elementValue._id;
    })
    return index;
  }






  // selectedAllProcesses:boolean;

  selectAllProcess(ev) {
    var self = this;
    self.markProcessSelected = false
    if (ev.target.checked == true) {
      for (var i = 0; i < this.processes.length; i++) {
        for (var j = 0; j < this.searcheFilteredDataProcess.length; j++) {
          if (this.searcheFilteredDataProcess[j] == this.processes[i]._id) {
            this.processes[i].IsSelected = true;
            self.markProcessSelected = true;
          }
        }
      }
    } else {
      this.processes.forEach(element => {
        element.IsSelected = false;

      });
      self.markProcessSelected = false;
    }
  }


  checkProcessselected(event) {
    var self = this;
    self.markProcessSelected = false
    //  console.log(selectedProcess);
    if (event.target.checked == true) {
      //console.log(event.target);
      this.isProcessSelected = true;
    }
    else {
      this.isProcessSelected = false;
    }
    var allSearchedSelectedProcess = true;
    if (_.size(this.processes)) {
      for (var i = 0; i < this.processes.length; i++) {
        for (var j = 0; j < this.searcheFilteredDataProcess.length; j++) {
          if (this.searcheFilteredDataProcess[j] == this.processes[i]._id) {
            if (this.processes[i].IsSelected) {
              self.markProcessSelected = true
            } else {
              allSearchedSelectedProcess = false;
            }
          }
        }
      }
    }
    if (allSearchedSelectedProcess) {
      this.selectedAllProcesses = true;
    } else {
      this.selectedAllProcesses = false;
    }
  }



  // confirmRemoveProcess(process_id, isglobal) {
  //   this.deleteProcessId=process_id;
  //   if (isglobal) {
  //     $('#processConfirmation').modal('toggle');
  //   } else {
  //     this.removeProcess('company');
  //   }
  // }

  removeProcess(process_id, IsGlobal) {
    var localStorageCompanyId = JSON.parse(localStorage.getItem("companyDetails")).companyID;
    // *** Global process selected in any AGENDA of one company should not be allowed for deleting from any company ***
    // console.log('localStorageCompanyId : ' + localStorageCompanyId + '  this.agendaDetailsCompanyID: ' + this.agendaDetailsCompanyID + ' IsGlobal : ' + IsGlobal);
    if (localStorageCompanyId != this.agendaDetailsCompanyID && IsGlobal) {
      $('#addWarningText').text("Process cannot be deleted as it is already selected in Agenda by one Company.");
      $('#warningModal').modal('toggle');
    } else {
      if (_.size(this.deletedProcesses)) {
        this.deletedProcesses.push(process_id);
      } else {
        this.deletedProcesses = [];
        this.deletedProcesses.push(process_id);
      }

      var addedData = [];
      addedData = this.addedProcess;
      this.addedProcess = [];
      $("#processTable").DataTable().destroy();
      var index = this.indexOfProcessArray(addedData, process_id);
      addedData.splice(index, 1);
      this.addedProcess = addedData;
      this.dtTriggerForAddedProcess.next();
    }
  }


  indexOfProcessArray(array: any[], process_id) {
    var index = _.findIndex(array, function (o) {
      if (o._id == process_id) { console.log('found element', o); }
      return o._id == process_id;
    })
    return index;
  }

  disableControl(editPermission: boolean) {
    if (!editPermission && environment.PSS == false) {
      this.agendaAddForm.controls.agendaNumber.disable();
      this.agendaAddForm.controls.IscategorySelected.disable();
      this.agendaAddForm.controls.IsMeetingAssigned.disable();
      this.agendaAddForm.controls.meetingType.disable();
      this.agendaAddForm.controls.selectCategory.disable();
      this.agendaAddForm.controls.meeting.disable();
      this.agendaAddForm.controls.agendaTitle.disable();
      this.agendaAddForm.controls.image.disable();
    }
  }
  // this. addedProcess = [];
  // $("#processTable").DataTable().destroy();
  // this.agendaService.deleteProcessFromAgenda(process_id,this.agendaId)
  //   .subscribe(result => {
  //     console.log(result);
  //     if (result.status == 0) {
  //      console.log(result);
  //       this. addedProcess =result.Agendaresult;
  //       this.dtTriggerForAddedProcess.next();
  //     }
  //   });

  // checkProcessselected(event){
  //   console.log(event.target);
  //   if (event.target.checked == true) {
  //     console.log(event.target);
  //     this.isProcessSelected = true;
  //   }
  //   else {
  //     this.isProcessSelected = false;
  //   }
  // }

  // agendaAccessRights(view) {
  //   const resourcesValue = JSON.parse(localStorage.getItem('resources'))
  //   _.forEach(resourcesValue, function (data) {
  //     if (data.Menu == "Agenda") {
  //       _.forEach(data.ChildResources, function (element) {
  //         if ((element.Url == "/agenda/view?goveva=true&email=")) {
  //           if (this.returnUrl != null || this.returnUrl != '/') {
  //             this.router.navigate([this.returnUrl]);
  //           }
  //           else {
  //             this.router.navigate(["dashboards/alpha"]);
  //           }
  //         }
  //       });
  //     }
  //   });
  // }
  processType: any;
  SearchprocessUserdefinedorPredefinedModel: any;

  CheckProcessType(item: any) {
    this.processType = item;
    this.getProcessListByProcessType(this.processType);

  }
  getProcessListByProcessType(processType) {
    this.processes = [];
    // if (this.dtElement.dtInstance != undefined) {
    //   this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
    //     dtInstance.destroy();
    //   });
    // }
    $("#processTablePopup").DataTable().destroy();

    var ispredefined = null;
    if (processType === 'Predefined') {
      ispredefined = true;
    } else if (processType === 'Userdefined') {
      ispredefined = false;
    }

    // console.log('ispredefined----->>>>', ispredefined);
    this.processMasterService.getProcessList()
      .subscribe(processList => {
        // console.log(processList)
        if (processList.status == 0) {
          var data = [];
          var processData = processList.processList;//$(processList.processList).filter(function (i, n) { return n.IsPredefined === ispredefined });
          for (var i = 0; i < processData.length; i++) {

            if (processData[i].MeetingTypeId != this.meetingTypeID && processData[i].IsPredefined == ispredefined) {
              processData[i].IsSelected = false;
              // console.log(processData[i].IsPredefined);
              data.push(processData[i]);
            }

          }
          this.processes = data;
    // console.log('this.processes----->>>>', this.processes);
          this.dtTriggerProcessAddingPopup.next();
        }
      })
  }
  showAllProcesses() {
    this.onAddProcessModelPopUpEvent();
    this.SearchprocessUserdefinedorPredefinedModel = null;
  }

  getGroupIndex() {
    this.agendaService.getGroupIndex().subscribe(data => {
      if (data.status == 0) {
        this.indexGroupingList = data.data
      }
    });
  }

  SaveIndexGrouping() {
    this.disabledOnclick = true;
    console.log('oooo0000', this.GroupingIndex,
      this.GroupingName, this.GroupingNumber
    )
    var IsGlobal;
    if (this.GroupingIndex == 'GlobalGroup') {
      IsGlobal = true;
    } else {
      IsGlobal = false;
    }

    var data = {
      'IsGlobal': IsGlobal,
      'GroupingName': this.GroupingName,
      'GroupingNumber': this.GroupingNumber
    }

    this.agendaService.addGroupIndex(data).subscribe(data => {
      this.disabledOnclick = false;
      if (data.status == 0) {
        $("#indexGrouping .close").click();
        this.GroupingIndex = undefined;
        this.GroupingName = undefined;
        this.GroupingNumber = undefined;
        this.alert.success('Group added successfully');
        $("#groupTable").DataTable().destroy();
        // this.GroupingNumberTouched = false;
        // this.GroupingNameTouched = false;
      } else {
        if (data.error.name == "ValidationError") {
          this.alert.error(data.error.message);
        } else {
          this.alert.error('something went wrong.');
        }
      }
      this.getGroupIndex();
    });

  }

  setGroupingType(typeOfGroup) {
    this.GroupingIndex = typeOfGroup;
  }

  changeGroup(event) {
    // console.log(event);
    var groupData = _.filter(this.indexGroupingList, function (obj) { return obj._id == event.target.value });
    // console.log(groupData);
    this.groupName = groupData[0].GroupName;
    this.groupNumber = groupData[0].GroupingNumber;
    this.agendaAddForm.controls.indexGrouping_id.setValue(groupData[0]._id);
  }

  groupingNumberFieldTouched() {
    this.GroupingNumberTouched = true;
  }

  groupingNameFieldTouched() {
    this.GroupingNameTouched = true;
  }

  onGetDepartmentDetails(id:any) {
    this.branchAndDepartmentService.getDepartment().subscribe((response:any) => {
      this.responseDepartment = response.data;
      setTimeout(()=>{
        this.agendaAddForm.controls.department.setValue(id);
      },1000)
    }, err => {
      console.log("🚀  file: branch.component.ts  line 35  BranchComponent  this.branchAndDepartmentService.getBranch ~ err", err)
    })
  }
}